import { Component, ElementRef, EnvironmentInjector, HostListener, ViewChild, ChangeDetectorRef, runInInjectionContext } from "@angular/core";
import { DatePipe, ViewportScroller } from "@angular/common";
import moment from "moment";
import { ProjectService } from "src/app/Services/project.service";
import { Observable, Subscription } from "rxjs";
import { UntypedFormControl, FormGroup, FormControl, Validators } from "@angular/forms";
import * as _ from "lodash";
import { config } from "src/app/config";
import { SharedService } from "src/app/Services/sharedService";
import swal from 'sweetalert2';
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { MatPaginator } from "@angular/material/paginator";
import { CustomTimeAgoPipe } from "src/app/time-ago.pipe";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { WelcomeComponent } from "src/app/welcome/welcome.component";
import { TrialOnboardingHelpActionsService } from "src/app/Services/trial-onboarding-help-actions.service";

import { MatDatepicker, MatDateRangePicker } from "@angular/material/datepicker";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { SweetAlertService } from "src/app/Services/sweet-alert.service";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import Swal from "sweetalert2";
import { MatMenuTrigger } from "@angular/material/menu";
import { sysConfig } from "./../../sysConfig";
import { colors } from "src/app/colors";

import { forkJoin } from 'rxjs';
import { DummyDataService } from "src/app/Services/dummy-data.service";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { ScreenshotTimeService } from "src/app/Services/screenshot-time.service";
import { Employee } from "src/app/interface/employee";
import { Team } from "src/app/interface/teams";
import { ApplicationUsage } from "src/app/interface/ApplicationUsage";
import { WebsiteUsage } from "src/app/interface/WebsiteUsage";
import { ApplicationLogsTimeLine, ApplicationUsageLogs } from "src/app/interface/ApplicationUsageLogs";
import { OnboardingChecklistService, OnboardingState } from "src/app/onboarding-checklist/onboarding-checklist.service";
import { ActivationJourneyService } from "src/app/onboarding-checklist/activation-journey.service";
import { hasCompanyRole } from "src/app/utils/role.utils";
import { ShiftService } from "src/app/Services/shift.service";
import { take } from "rxjs/operators";
import { EntitlementsService } from "src/app/Services/entitlements.service";
import { trackClarityEvent } from "src/app/utils/clarity-event.util";
import { processTimelineSessionLogs } from "src/app/utils/timeline-session-logs.util";
import { DemoEnvironmentService } from "src/app/Services/demo-environment.service";

declare var $;
const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
const date = today.getDate();

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
}
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
  providers: [DatePipe],
  standalone: false
})
export class DashboardComponent {
  startPage = 1;
  endPage = 10;
  totalPage = 1;
  totalStack_user = 0;
  offlinePercentage: any = 0;
  onlinePercentage: any = 0;
  stackedArr;
  selectedEmp;
  isloading = false;
  startDate: any;
  chartdata;
  sysConfig = sysConfig
  filterTeamStackArr = [];
  endDate: any = new Date();
  private closeMenuTimeout: any = null;
  enddate = new Date();
  isPiechartLoad = false;
  isPieChartLoadWebsite = false;
  onlinePercentageIcon = "north"
  offlinePercentageIcon = "north"
  searchStack = '';
  startdate;
  stackDate;
  maxDate = new Date();
  maxApplicationUsageDate: any = new Date().toISOString();
  maxWebsiteUsageDate: any = new Date().toISOString();
  minApplicationUsageDate: any = new Date().toISOString();
  minWebsiteUsageDate: any = new Date().toISOString();
  minDateForTimeLine: any = new Date().toISOString();
  maxDateForTimeLine: any = new Date().toISOString();
  skeletonLoaders = Array(8).fill(0); // Adjust the array size as needed
  skeletonTheme = {
    'border-radius': '2',
    height: '280px',
    margin: '5px'
  };
  startDateForInput: any;
  endDateForInput: any = new Date();
  startDateWebsiteUsageChart: any;
  endDateWebsiteUsageChart: any = new Date();

  users = [];
  userIds = [];
  totalInactiveTime = 0;
  totalWorkHours = 0;
  totalProductiveHours = 0;
  donutChartData: any = [];
  pieChartdata: any = [];
  pieChartDataWebsiteUsage: any;
  pieChartWebsiteUsageLabel: any;
  stackedChartData;
  searchText: string;
  userName = "";
  userId;
  PhotoList: any = [];
  filteredData: Observable<any[]>;
  filterControl = new UntypedFormControl();
  onlineUsers = 0;
  offlineUsers = 0;
  invitedUsers = 0;
  idleUsers = 0;
  totalUsers = 0;
  allUsersCount = 0;
  invitedUsersList: Employee[] = [];
  absentUsersList = [];
  onlineUsersForCard: Employee[] = [];
  idleUsersForCard = [];
  offlineUsersForCard = [];
  filePath = config.baseMediaUrl;
  removable = true;
  loading = false;
  page = 1;
  isData = true;
  teamList = [];
  newSessionTimeline: any = [];
  userDataSubscription: Subscription;
  startdate_ss: any;
  enddate_ss: any;
  @ViewChild("stateInput", { static: true }) stateInput!: ElementRef;
  @ViewChild("EmpPaginator", { static: false }) EmpPaginator: MatPaginator;
  usedAppInfo: any;
  pieChartLabels: any = [];
  barChartLast10Data: any = [];
  barChartLast10Labels: any = [];
  barChartTop10Data: any = [];
  barChartTop10Labels: any = [];
  selectedOptions: any = [];
  showError = false;
  errorMessage = "";
  selected: any;
  filterUsers: any[];
  userList: Employee[] = [];
  isShowPieChart = true;
  usersRef: AngularFireList<User> = null;
  private dbPath: string | null = null;
  userImageClass = 'avatar-img';
  // Indicates whether dashboard is currently rendering demo data (dummy users)
  isShowingDemoData: boolean = false;

  // Setup banner
  showSetupBanner: boolean = false;
  private hideSetupBannerForSession: boolean = false;
  private readonly SETUP_BANNER_SESSION_HIDE_KEY = 'supersee_setup_banner_hidden_session';
  setupBannerTitle = 'Connect this computer';
  setupBannerSubtitle = 'See exactly what SuperSee captures before inviting your team. Takes about 5 minutes.';
  setupBannerCta = 'Start setup';
  private setupBannerTargetStep = 'intro';
  private setupBannerPhase = 'connect_computer';
  /** User explicitly opted into sample/demo dashboard data (non-interruptive). */
  private demoOptInRefreshSub?: Subscription;

  public searchMultiCtrl: FormControl = new FormControl();
  public searchCtrl: FormControl = new FormControl();
  pieChartData: any[];
  pieChartLabel: any[];
  pieChartDisplayData: any[];
  pieChartDisplayDataWebsite: any[];
  donutChartLabel: any[];
  donutChartDisplayData: any[];
  x_min: any;
  stackedChartlabel: any = [];
  tempDataTooltip: any = [];
  stackedChartIds: any = [];

  x_max: any;
  _isStackbarLoading: boolean = false;
  _isTotalHoursLoading: boolean = false;
  _isAppUsageLoading: boolean = false;
  isAdmin: boolean = false
  isManager: boolean = false
  isTeamLead: boolean = false
  workingHoursColor = colors.workingHours
  appUsageColor = colors.appUsageColor
  workingHours: any;
  appUsageHours: any;
  isPaid: boolean = false;
  timelineSection = true;
  screenshotSection = false;
  timelineBackground = 'timeline-section-btn-bg-color';
  screenshotBackground = '';
  rencetScreenshots;
  total_ss = 0;
  /** Company shift IANA zone for naive screenshot timestamps */
  shiftTimezone: string | null = null;
  regionHint: string | null = null;
  pageSize = 25;
  offset = 0;
  currentPage = 1;
  scrollTarget = '';
  teamsListForFilter: any = [];
  selectedTeam: any;
  currentTeam = '';
  isSingleDayActive: boolean = true;
  isVirtualShiftActive: boolean = false;
  timelineSelectedDate: { startDate: moment.Moment, endDate: moment.Moment };
  selectedDateAndTime: { startDate: moment.Moment, endDate: moment.Moment };
  /** Material date range for timeline 48h mode */
  timeline48Range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  /** Material date range + native time inputs for dashboard screenshots filter */
  screenshotDateRange = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  screenshotStartTimeStr = '00:00:00';
  screenshotEndTimeStr = '23:59:59';
  timelineStartTime: string = null;
  timelineEndTime: string = null;
  /** Stable model for single-day mat-datepicker (never bind ngModel to a getter that returns new Date()). */
  timelineSingleDayModel: Date | null = null;
  timelineMinDate: Date | null = null;
  timelineMaxDate: Date | null = null;
  timelineMatRangeMax: Date | null = null;

  /** Debounce shift time edits so the stacked-chart API is not called on every native time-picker step. */
  private readonly timelineShiftFilterDebounceMs = 500;
  private timelineShiftFilterDebounceId: ReturnType<typeof setTimeout> | null = null;

  /** Local wall-clock strings for stacked-chart (toISOString shifts calendar day in non-UTC zones). */
  get timelineChartStartLocal(): string | undefined {
    return this.timelineSelectedDate?.startDate?.format('YYYY-MM-DDTHH:mm:ss');
  }

  get timelineChartEndLocal(): string | undefined {
    return this.timelineSelectedDate?.endDate?.format('YYYY-MM-DDTHH:mm:ss');
  }

  private refreshTimelineMaterialDateBounds(): void {
    this.timelineMinDate = this.toMaterialDate(this.minDateForTimeLine);
    this.timelineMaxDate = this.toMaterialDate(this.maxDateForTimeLine);
    this.timelineMatRangeMax =
      this.timelineMaxDate != null ? moment(this.timelineMaxDate).add(1, 'day').toDate() : null;
  }

  /** Sync `timelineSingleDayModel` from `timelineSelectedDate` without churning references. */
  private syncTimelineSingleDayModelFromMoments(): void {
    if (!this.timelineSelectedDate?.startDate) {
      this.timelineSingleDayModel = null;
      return;
    }
    const next = this.timelineSelectedDate.startDate.clone().startOf('day').toDate();
    if (this.timelineSingleDayModel?.getTime() === next.getTime()) {
      return;
    }
    this.timelineSingleDayModel = next;
  }

  private toMaterialDate(v: any): Date | null {
    if (v == null || v === '') {
      return null;
    }
    const d = v instanceof Date ? new Date(v.getTime()) : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  onTimelineSingleDayPicked(value: Date | null): void {
    if (!value) {
      return;
    }
    const formatted = moment(value).format('YYYY-MM-DD');
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-date': formatted,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }


  onTimeline48RangeClosed(): void {
    let start = this.timeline48Range.value.start;
    let end = this.timeline48Range.value.end;
    if (!start || !end) {
      return;
    }
    const startMom = moment(start).startOf('day');
    let endMom = moment(end).endOf('day');

    // Restrict to exactly 2 consecutive days (start + 1 day max)
    const maxAllowedEnd = startMom.clone().add(1, 'day').endOf('day');
    if (endMom.isAfter(maxAllowedEnd)) {
      endMom = maxAllowedEnd;
      // Patch the form control to reflect the clamped end date
      this.timeline48Range.patchValue({ start: startMom.toDate(), end: endMom.toDate() });
    }
    if (endMom.isSame(startMom, 'day')) {
      endMom = startMom.clone().add(1, 'day').endOf('day');
    }

    const formatted = `${startMom.format('YYYY-MM-DD')}_${endMom.format('YYYY-MM-DD')}`;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-date': formatted,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }


  private patchTimeline48RangeFromMoments(): void {
    if (!this.timelineSelectedDate?.startDate || !this.timelineSelectedDate?.endDate) {
      return;
    }
    this.timeline48Range.patchValue(
      {
        start: this.timelineSelectedDate.startDate.clone().startOf('day').toDate(),
        end: this.timelineSelectedDate.endDate.clone().startOf('day').toDate(),
      },
      { emitEvent: false }
    );
  }

  private patchScreenshotDateRangeFromMoments(): void {
    if (!this.selectedDateAndTime?.startDate || !this.selectedDateAndTime?.endDate) {
      return;
    }
    this.screenshotDateRange.patchValue(
      {
        start: this.selectedDateAndTime.startDate.clone().startOf('day').toDate(),
        end: this.selectedDateAndTime.endDate.clone().startOf('day').toDate(),
      },
      { emitEvent: false }
    );
    this.screenshotStartTimeStr = this.selectedDateAndTime.startDate.format('HH:mm:ss');
    this.screenshotEndTimeStr = this.selectedDateAndTime.endDate.format('HH:mm:ss');
  }

  private parseDateAndTimeString(d: Date, timeStr: string): moment.Moment {
    const parts = (timeStr || '00:00:00').split(':');
    const h = Math.min(23, Math.max(0, parseInt(parts[0], 10) || 0));
    const m = Math.min(59, Math.max(0, parseInt(parts[1], 10) || 0));
    const s = Math.min(59, Math.max(0, parseInt(parts[2], 10) || 0));
    return moment(d).startOf('day').hour(h).minute(m).second(s).millisecond(0);
  }

  onDashboardScreenshotFilterChange(): void {
    const startD = this.screenshotDateRange.value.start;
    const endD = this.screenshotDateRange.value.end;
    if (!startD || !endD) {
      return;
    }
    this.selectedDateAndTime = {
      startDate: this.parseDateAndTimeString(startD, this.screenshotStartTimeStr),
      endDate: this.parseDateAndTimeString(endD, this.screenshotEndTimeStr),
    };
    this.change(null);
  }

  private isTimelineMultiDaySelection(): boolean {
    if (!this.timelineSelectedDate?.startDate || !this.timelineSelectedDate?.endDate) {
      return false;
    }
    return !this.timelineSelectedDate.startDate.isSame(this.timelineSelectedDate.endDate, 'day');
  }

  selectFormControler = new FormControl();
  employeeCards = [
    {
      tooltip: "Total Employees",
      icon: "group",
      bgClass: "employee-card-icon-div-bg-total employee-card-icon-div-color-total",
      textColor: "employee-card-icon-div-color-total",
      value: this.onlineUsers + this.offlineUsers + this.idleUsers,
      label: "Employees",
      showBadge: false
    },
    {
      tooltip: "Online Employees",
      icon: "person",
      bgClass: "employee-card-icon-div-bg-online employee-card-icon-div-color-online",
      textColor: "employee-card-icon-div-color-online",
      value: this.onlineUsers,
      label: "Online",
      showBadge: true,
      badgeClass: "employee-card-icon-div-bg-online employee-card-icon-div-color-online",
      percentage: this.onlinePercentage,
      percentageIcon: this.onlinePercentageIcon
    },
    {
      tooltip: "Offline Employees",
      icon: "person_off",
      bgClass: "employee-card-icon-div-bg-offline employee-card-icon-div-color-offline",
      textColor: "employee-card-icon-div-color-offline",
      value: this.offlineUsers,
      label: "Offline",
      showBadge: true,
      badgeClass: "employee-card-icon-div-bg-offline employee-card-icon-div-color-offline",
      percentage: this.offlinePercentage,
      percentageIcon: this.offlinePercentageIcon
    },
    {
      tooltip: "Teams",
      icon: "groups",
      bgClass: "employee-card-icon-div-bg-team employee-card-icon-div-color-team",
      textColor: "employee-card-icon-div-color-team",
      value: this.teamList.length,
      label: "Teams",
      showBadge: false
    }
  ];
  quotaAllowedToCreateUser = 0;
  displayTotalUsers = "";

  private _currentState;
  @ViewChild('timelineSingleDp') timelineSingleDp!: MatDatepicker<Date>;
  @ViewChild('timelineRangeDp') timelineRangeDp!: MatDateRangePicker<Date>;
  @ViewChild('screenshotRangeDp') screenshotRangeDp!: MatDateRangePicker<Date>;
  selectEnable: boolean;
  offlineEmployee: any[] = [];
  onlineEmployee: any[] = [];
  idleEmployee: any[] = [];
  @ViewChild('onlineMenuTrigger') onlineMenuTrigger!: MatMenuTrigger;
  @ViewChild('offlineMenuTrigger') offlineMenuTrigger!: MatMenuTrigger;
  @ViewChild('idleMenuTrigger') idleMenuTrigger!: MatMenuTrigger;
  teamSize = 0;
  employeeMultiCtrl: FormControl = new FormControl('', Validators.required);



  constructor(
    private datePipe: DatePipe,
    private _projectService: ProjectService,
    private db: AngularFireDatabase,
    private _messagingService: MessagingServiceService,
    private _sharedServices: SharedService,
    private scroller: ViewportScroller,
    private customtimeAgoPipe: CustomTimeAgoPipe,
    private router: Router,
    public dialog: MatDialog,
    public trialOnboardingHelp: TrialOnboardingHelpActionsService,
    private http: HttpClient,
    private sweetAlertService: SweetAlertService,
    private cdr: ChangeDetectorRef,
    private _dummyDataService: DummyDataService,
    private tokenEncryptionService: TokenEncryptionService,
    private onboardingService: OnboardingChecklistService,
    private activationJourney: ActivationJourneyService,
    private injector: EnvironmentInjector,
    private screenshotTime: ScreenshotTimeService,
    private shiftService: ShiftService,
    private route: ActivatedRoute,
    private entitlementsService: EntitlementsService,
    private demoEnvironment: DemoEnvironmentService,
  ) {
    this.startdate = new Date(year, month, date);
    this.startdate_ss = new Date(year, month, date - 1);
    this.startDateForInput = new Date(year, month, date, 0, 0, 0);
    this.startDateWebsiteUsageChart = new Date(year, month, date, 0, 0, 0);
    this.endDateWebsiteUsageChart = new Date(year, month, date, 23, 59, 59);

    const start = moment().startOf('day');
    const end = moment().endOf('day');
    this.timelineSelectedDate = { startDate: start, endDate: end };
    this.refreshTimelineMaterialDateBounds();
    this.syncTimelineSingleDayModelFromMoments();
    const nowInit = moment();
    const thirtyDaysAgo = nowInit.clone().subtract(30, 'days');
    this.selectedDateAndTime = {
      startDate: thirtyDaysAgo.clone().startOf('day'),
      endDate: nowInit.clone().endOf('day'),
    };
    this._projectService.updateAdminLoginData({ data: true })
    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;

    this.stackDate = this.enddate;

    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('Dashboard: dbPath updated to:', this.dbPath);
        // Re-initialize Firebase reference if needed
        if (this.usersRef) {
          this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
        }
      }
    });

    // Only initialize Firebase reference if dbPath exists
    if (this.dbPath) {
      this.usersRef = db.list(this.dbPath);
    } else {
      console.warn('Dashboard: dbPath not set, Firebase reference not initialized');
    }

    this.maxDate = today;
  }

  private updateSetupBannerVisibility(state: OnboardingState = this.onboardingService.getState()): void {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    if (!hasCompanyRole(user)) {
      this.showSetupBanner = false;
      this.cdr.detectChanges();
      return;
    }
    // Paused journey: the floating resume bar is the one invitation. Don't stack
    // a second "Resume setup" rocket banner on Dashboard.
    if (this.activationJourney.isEnabled) {
      const js = this.activationJourney.getState();
      const paused = js.journeyStatus === 'paused' || (!!js.continuedLater && !js.finished);
      if (paused && !this.activationJourney.isFinishedOrSkipped()) {
        this.showSetupBanner = false;
        this.cdr.detectChanges();
        return;
      }
    }

    this.updateSetupBannerContent(state);
    const screenshotStep = state?.steps?.find(step => step.id === 'request_screenshot');
    const isAllCompleted =
      this.onboardingService.isAllCompleted() ||
      screenshotStep?.status === 'completed';
    const isEligible = this.onboardingService.isEligible();

    this.showSetupBanner =
      !this.isPaid &&
      !this.hideSetupBannerForSession &&
      sessionStorage.getItem(this.SETUP_BANNER_SESSION_HIDE_KEY) !== 'true' &&
      isEligible &&
      !isAllCompleted;
    this.cdr.detectChanges();
  }

  private updateSetupBannerContent(state: OnboardingState): void {
    const createStep = state?.steps?.find(step => step.id === 'create_employee');
    const installStep = state?.steps?.find(step => step.id === 'install_agent');
    const hasSetupStarted = this.onboardingService.hasSetupStarted(state);

    if (!hasSetupStarted) {
      this.setupBannerTitle = 'Connect this computer';
      this.setupBannerSubtitle = 'See exactly what SuperSee captures before inviting your team. Takes about 5 minutes.';
      this.setupBannerCta = 'Start setup';
      this.setupBannerTargetStep = 'intro';
      this.setupBannerPhase = 'connect_computer';
      return;
    }

    if (!createStep?.completed) {
      this.setupBannerTitle = 'Finish connecting this computer';
      this.setupBannerSubtitle = 'Continue where you left off to create your temporary test device.';
      this.setupBannerCta = 'Resume setup';
      this.setupBannerTargetStep = 'intro';
      this.setupBannerPhase = 'connect_computer_in_progress';
      return;
    }

    if (installStep?.completed) {
      this.setupBannerTitle = 'Your first screenshot is almost ready';
      this.setupBannerSubtitle = 'Keep SuperSee running while we capture your first screenshot.';
      this.setupBannerCta = 'View progress';
      this.setupBannerTargetStep = 'download';
      this.setupBannerPhase = 'screenshot_pending';
      return;
    }

    if (installStep?.status === 'in_progress') {
      this.setupBannerTitle = 'Finish connecting SuperSee';
      this.setupBannerSubtitle = 'Run the installer to connect this computer automatically.';
      this.setupBannerCta = 'Resume setup';
      this.setupBannerTargetStep = 'download';
      this.setupBannerPhase = 'waiting_for_connection';
      return;
    }

    this.setupBannerTitle = 'Install SuperSee';
    this.setupBannerSubtitle = 'Download SuperSee and connect this computer.';
    this.setupBannerCta = 'Continue setup';
    this.setupBannerTargetStep = 'download';
    this.setupBannerPhase = 'install_supersee';
  }

  resumeSetup(): void {
    trackClarityEvent('activation_dashboard_banner_clicked', {
      phase: this.setupBannerPhase,
      target_step: this.setupBannerTargetStep
    });
    this.onboardingService.resumeOnboarding();
    this.router.navigate(['/setup'], {
      queryParams: { step: this.setupBannerTargetStep, t: Date.now() }
    });
  }

  dismissSetupBanner(): void {
    trackClarityEvent('activation_dashboard_banner_snoozed', {
      phase: this.setupBannerPhase
    });
    this.hideSetupBannerForSession = true;
    sessionStorage.setItem(this.SETUP_BANNER_SESSION_HIDE_KEY, 'true');
    this.updateSetupBannerVisibility();
  }

  ngOnDestroy() {
    this.clearPendingTimelineShiftFilterDebounce();
    this.isShowPieChart = false;
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this.demoOptInRefreshSub?.unsubscribe();
    this.timelineConductSub?.unsubscribe();

    this._messagingService.resetData();
  }

  isConductIntegrated = false;
  isImportingConductTimelogs = false;
  conductTimelogs: any[] = [];
  timelineConductTimelogs: any[] = [];
  groupedConductTimelogs: any[] = [];
  groupedConductProjects: any[] = [];
  conductSelectedDate: moment.Moment = moment();
  conductDateModel: Date = moment().toDate();
  maxConductDate: Date = moment().endOf('day').toDate();
  minConductDate: Date | null = null;

  get isConductNextDisabled(): boolean {
    if (!this.conductSelectedDate) return false;
    const maxBoundary = this.maxConductDate ? moment(this.maxConductDate).startOf('day') : moment().startOf('day');
    return this.conductSelectedDate.clone().startOf('day').isSameOrAfter(maxBoundary);
  }

  get isConductPreviousDisabled(): boolean {
    if (!this.conductSelectedDate || !this.minConductDate) return false;
    return this.conductSelectedDate.clone().startOf('day').isSameOrBefore(moment(this.minConductDate).startOf('day'));
  }

  onConductPreviousDate(): void {
    if (this.isConductPreviousDisabled) {
      return;
    }
    this.conductSelectedDate = this.conductSelectedDate.clone().subtract(1, 'day');
    this.conductDateModel = this.conductSelectedDate.toDate();
    const dateStr = this.conductSelectedDate.format('YYYY-MM-DD');
    this.fetchConductTimelogs(true, dateStr, dateStr);
  }

  onConductNextDate(): void {
    if (this.isConductNextDisabled) {
      return;
    }
    this.conductSelectedDate = this.conductSelectedDate.clone().add(1, 'day');
    this.conductDateModel = this.conductSelectedDate.toDate();
    const dateStr = this.conductSelectedDate.format('YYYY-MM-DD');
    this.fetchConductTimelogs(true, dateStr, dateStr);
  }

  onConductDatePicked(pickedDate: any): void {
    if (pickedDate) {
      const pickedMom = moment(pickedDate);
      const maxBoundary = this.maxConductDate ? moment(this.maxConductDate).startOf('day') : moment().startOf('day');
      if (pickedMom.startOf('day').isAfter(maxBoundary)) {
        return;
      }
      if (this.minConductDate && pickedMom.startOf('day').isBefore(moment(this.minConductDate).startOf('day'))) {
        return;
      }
      this.conductSelectedDate = pickedMom;
      this.conductDateModel = this.conductSelectedDate.toDate();
      const dateStr = this.conductSelectedDate.format('YYYY-MM-DD');
      this.fetchConductTimelogs(true, dateStr, dateStr);
    }
  }

  private extractDateString(val: any, fallbackMoment?: moment.Moment): string {
    if (val) {
      const m = moment(val);
      if (m.isValid()) {
        return m.format('YYYY-MM-DD');
      }
    }
    return fallbackMoment?.isValid() ? fallbackMoment.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
  }

  private lastFetchedTimelineConductRange: string = '';
  private timelineConductSub?: Subscription;

  fetchTimelineConductTimelogs(startStr?: string, endStr?: string, force: boolean = false): void {
    const sDate = startStr || this.extractDateString(null, this.timelineSelectedDate?.startDate);
    const eDate = endStr || this.extractDateString(null, this.timelineSelectedDate?.endDate) || sDate;
    if (!sDate) {
      return;
    }
    const finalEndDate = eDate || sDate;
    const rangeKey = `${sDate}_${finalEndDate}`;

    if (!force && this.lastFetchedTimelineConductRange === rangeKey && this.timelineConductTimelogs && this.timelineConductTimelogs.length > 0) {
      return;
    }

    // Cancel any in-flight request to prevent race conditions when date changes rapidly
    this.timelineConductSub?.unsubscribe();

    // Clear stale logs from prior dates so they don't linger on the new date
    if (this.lastFetchedTimelineConductRange !== rangeKey) {
      this.timelineConductTimelogs = [];
    }

    const user = this.tokenEncryptionService.getEncryptedItem<any>('user') || {};
    const companyId = user?.company_id || user?.id || user?.userId || 0;

    const performFetch = () => {
      const handleTimelineLogs = (rawLogs: any[]) => {
        // Discard if user navigated to a different range while HTTP was in-flight
        const currentStart = startStr || this.extractDateString(null, this.timelineSelectedDate?.startDate);
        const currentEnd = endStr || this.extractDateString(null, this.timelineSelectedDate?.endDate) || currentStart;
        const currentRangeKey = `${currentStart}_${currentEnd || currentStart}`;
        if (currentRangeKey !== rangeKey) {
          return;
        }

        let filteredLogs = rawLogs;
        if (this.userList && this.userList.length > 0) {
          const loggedInUser = this.tokenEncryptionService?.getEncryptedItem<any>('user') || {};
          const userRoles = Array.isArray(loggedInUser?.roles) ? loggedInUser.roles : [];
          const isCompanyAdmin = userRoles.includes('company') || loggedInUser?.role === 'company' || loggedInUser?.role === 'administrator';

          if (!isCompanyAdmin) {
            const allowedUserIds = new Set(this.userList.map((u: any) => String(u.id || u.ID || u.userId)));
            const loggedInUserId = loggedInUser?.id || loggedInUser?.userId;
            if (loggedInUserId) {
              allowedUserIds.add(String(loggedInUserId));
            }
            filteredLogs = rawLogs.filter((log: any) => {
              const uid = String(log.supersee_user_id || log.supersee_user || '');
              return uid && allowedUserIds.has(uid);
            });
          }
        }

        this.lastFetchedTimelineConductRange = rangeKey;
        this.timelineConductTimelogs = filteredLogs.map((log: any) => this.mapConductTimelogUser(log));
        this.cdr.detectChanges();
      };

      this.timelineConductSub = this._projectService.fetchConductTimelogs({
        supersee_company_id: companyId,
        requesting_user_id: user?.id,
        start_date: sDate,
        end_date: finalEndDate
      }).subscribe({
        next: (res: any) => {
          const rawLogs = res?.timelogs || res?.data || (Array.isArray(res) ? res : []);
          if (rawLogs && rawLogs.length > 0) {
            handleTimelineLogs(rawLogs);
          } else {
            this.timelineConductSub = this._projectService.getSavedConductTimelogs(companyId, null, null, sDate, finalEndDate).subscribe({
              next: (savedRes: any) => {
                const savedLogs = savedRes?.timelogs || savedRes?.data || (Array.isArray(savedRes) ? savedRes : []);
                handleTimelineLogs(savedLogs);
              },
              error: () => handleTimelineLogs([])
            });
          }
        },
        error: () => {
          this.timelineConductSub = this._projectService.getSavedConductTimelogs(companyId, null, null, sDate, finalEndDate).subscribe({
            next: (savedRes: any) => {
              const savedLogs = savedRes?.timelogs || savedRes?.data || (Array.isArray(savedRes) ? savedRes : []);
              handleTimelineLogs(savedLogs);
            },
            error: () => handleTimelineLogs([])
          });
        }
      });
    };

    if (this.isConductIntegrated) {
      performFetch();
    } else {
      this.timelineConductSub = this._projectService.getConductIntegrationStatus(companyId).subscribe({
        next: (statusRes: any) => {
          if (!statusRes || !statusRes.is_integrated) {
            this.isConductIntegrated = false;
            return;
          }

          this.isConductIntegrated = true;
          performFetch();
        },
        error: () => {}
      });
    }
  }

  navigateToConductLogs(projectId?: string, projectName?: string): void {
    const formattedDate = (this.conductSelectedDate || moment()).format('YYYY-MM-DD');
    const queryParams: Record<string, string> = { date: formattedDate };
    if (projectId && projectId !== 'unassigned') {
      queryParams['projectId'] = projectId;
    }
    if (projectName) {
      queryParams['projectName'] = projectName;
    }
    this.router.navigate(['/conduct-timelogs'], { queryParams });
  }

  groupConductProjects(logs: any[]): any[] {
    if (!logs || !Array.isArray(logs) || logs.length === 0) {
      return [];
    }

    const projectsMap = new Map<string, any>();

    logs.forEach(log => {
      const projId = String(log.project_id || log.conduct_project_id || log.project_name || 'unassigned');
      const projName = log.project_name || 'General Tasks';

      if (!projectsMap.has(projId)) {
        projectsMap.set(projId, {
          project_id: projId,
          project_name: projName,
          total_duration_seconds: 0,
          total_worked_hours: '0h 00m',
          total_tasks_count: 0,
          tasksSet: new Set<string>(),
          contributorsMap: new Map<string, { name: string; email: string }>(),
          contributors: []
        });
      }

      const pGroup = projectsMap.get(projId);
      const durSecs = parseInt(log.duration_time_second, 10) || 0;
      pGroup.total_duration_seconds += durSecs;

      const taskKey = String(log.task_unique_id || log.task_id || log.task_title || '');
      if (taskKey) {
        pGroup.tasksSet.add(taskKey);
      } else {
        pGroup.total_tasks_count += 1;
      }

      const userKey = String(log.supersee_user_id || log.conduct_user_id || log.employee_name || 'unmapped');
      if (!pGroup.contributorsMap.has(userKey)) {
        pGroup.contributorsMap.set(userKey, {
          name: log.employee_name || 'User',
          email: log.employee_email || ''
        });
      }
    });

    const palettes = [
      { tagBg: 'bg-indigo-50', tagText: 'text-indigo-700', tagBorder: 'border-indigo-100', barHex: '#5459d1' },
      { tagBg: 'bg-emerald-50', tagText: 'text-emerald-700', tagBorder: 'border-emerald-200', barHex: '#10b981' },
      { tagBg: 'bg-amber-50', tagText: 'text-amber-800', tagBorder: 'border-amber-200', barHex: '#f59e0b' },
      { tagBg: 'bg-sky-50', tagText: 'text-sky-700', tagBorder: 'border-sky-200', barHex: '#0284c7' },
      { tagBg: 'bg-pink-50', tagText: 'text-pink-700', tagBorder: 'border-pink-200', barHex: '#ec4899' },
      { tagBg: 'bg-purple-50', tagText: 'text-purple-700', tagBorder: 'border-purple-200', barHex: '#8b5cf6' },
      { tagBg: 'bg-teal-50', tagText: 'text-teal-700', tagBorder: 'border-teal-200', barHex: '#0d9488' }
    ];

    const result = Array.from(projectsMap.values());
    result.forEach((p, idx) => {
      const totalSecs = p.total_duration_seconds;
      const h = Math.floor(totalSecs / 3600);
      const m = Math.floor((totalSecs % 3600) / 60);
      p.total_worked_hours = `${h}h ${String(m).padStart(2, '0')}m`;
      p.total_tasks_count = p.tasksSet.size > 0 ? p.tasksSet.size : p.total_tasks_count || 1;
      p.contributors = Array.from(p.contributorsMap.values());
      p.colorPalette = palettes[idx % palettes.length];
    });

    return result;
  }

  groupConductTimelogs(logs: any[]): any[] {
    if (!logs || !Array.isArray(logs) || logs.length === 0) {
      return [];
    }

    const groupsMap = new Map<string, any>();

    logs.forEach(log => {
      const key = String(log.supersee_user_id || log.conduct_user_id || log.employee_name || 'unmapped');

      if (!groupsMap.has(key)) {
        groupsMap.set(key, {
          user_key: key,
          supersee_user_id: log.supersee_user_id,
          conduct_user_id: log.conduct_user_id,
          employee_name: log.employee_name || 'Unmapped User',
          employee_email: log.employee_email || '',
          total_duration_seconds: 0,
          total_worked_hours: '00:00:00',
          expanded: true,
          logs: []
        });
      }

      const group = groupsMap.get(key);
      group.logs.push(log);

      const durSecs = parseInt(log.duration_time_second, 10) || 0;
      group.total_duration_seconds += durSecs;
    });

    const result = Array.from(groupsMap.values());
    result.forEach(group => {
      const totalSecs = group.total_duration_seconds;
      const h = Math.floor(totalSecs / 3600);
      const m = Math.floor((totalSecs % 3600) / 60);
      const s = totalSecs % 60;
      group.total_worked_hours = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    });

    return result;
  }

  isConductDrawerOpen = false;
  selectedConductGroup: any = null;
  selectedConductGroupIndex = 0;
  selectedConductUserTimelineSessions: any[] = [];

  openConductDrawer(group: any, index?: number): void {
    if (!group) {
      return;
    }
    this.selectedConductGroup = group;
    if (index !== undefined && index >= 0) {
      this.selectedConductGroupIndex = index;
    } else {
      const idx = this.groupedConductTimelogs.findIndex(g => g.user_key === group.user_key);
      this.selectedConductGroupIndex = idx >= 0 ? idx : 0;
    }
    this.updateSelectedConductTimelineSessions();
    this.isConductDrawerOpen = true;

    this._sharedServices.componentDrawerSubject.next({
      componentName: 'conduct-timelogs',
      componentAction: 'open',
      componentWidth: 680,
      componentData: {
        group: this.selectedConductGroup,
        groups: this.groupedConductTimelogs,
        currentIndex: this.selectedConductGroupIndex,
        selectedDate: this.conductSelectedDate,
        startDate: this.conductSelectedDate,
        endDate: this.conductSelectedDate,
        users: this.userList,
        userTimelineSessions: this.selectedConductUserTimelineSessions
      }
    });
  }

  closeConductDrawer(): void {
    this.isConductDrawerOpen = false;
    this.selectedConductGroup = null;
    this.selectedConductUserTimelineSessions = [];
    this._sharedServices.componentDrawerSubject.next({
      componentName: 'conduct-timelogs',
      componentAction: 'close',
      componentData: null,
      componentWidth: 0
    });
  }

  onConductDrawerNavigate(index: number): void {
    if (index >= 0 && index < this.groupedConductTimelogs.length) {
      this.selectedConductGroupIndex = index;
      this.selectedConductGroup = this.groupedConductTimelogs[index];
      this.updateSelectedConductTimelineSessions();
    }
  }

  private updateSelectedConductTimelineSessions(): void {
    if (!this.selectedConductGroup) {
      this.selectedConductUserTimelineSessions = [];
      return;
    }
    const userId = String(this.selectedConductGroup.supersee_user_id || this.selectedConductGroup.user_key || '');
    if (!userId) {
      this.selectedConductUserTimelineSessions = [];
      return;
    }

    // Only supply preloaded timeline sessions if the dashboard timeline chart is displaying
    // the exact same single calendar date as conductSelectedDate, and candidate sessions match that date.
    const conductDateStr = moment(this.conductSelectedDate).format('YYYY-MM-DD');
    const isSingleDay = !!this.timelineSelectedDate?.startDate &&
      !!this.timelineSelectedDate?.endDate &&
      this.timelineSelectedDate.startDate.isSame(this.timelineSelectedDate.endDate, 'day');
    const isSameDate = isSingleDay &&
      this.timelineSelectedDate.startDate.format('YYYY-MM-DD') === conductDateStr;

    if (isSameDate && this.stackedChartIds && this.stackedChartIds.length > 0) {
      const idx = this.stackedChartIds.findIndex(id => String(id) === userId);
      if (idx !== -1 && this.newSessionTimeline && this.newSessionTimeline[idx]) {
        const candidateSessions = this.newSessionTimeline[idx];
        const hasMatchingDate = Array.isArray(candidateSessions) && candidateSessions.length > 0 &&
          candidateSessions.some((s: any) => {
            const raw = s?.date || s?.inTime || s?.in;
            return raw && moment(raw).format('YYYY-MM-DD') === conductDateStr;
          });
        if (hasMatchingDate) {
          this.selectedConductUserTimelineSessions = candidateSessions;
          return;
        }
      }
    }
    this.selectedConductUserTimelineSessions = [];
  }

  toggleConductGroup(group: any, index?: number): void {
    this.openConductDrawer(group, index);
  }

  getUserTimelineSessionsForGroup(group: any): any[] {
    if (!group) return [];
    const userId = String(group.supersee_user_id || group.user_key || '');
    if (!userId) return [];
    if (this.stackedChartIds && this.stackedChartIds.length > 0) {
      const idx = this.stackedChartIds.findIndex(id => String(id) === userId);
      if (idx !== -1 && this.newSessionTimeline && this.newSessionTimeline[idx]) {
        return this.newSessionTimeline[idx];
      }
    }
    return [];
  }

  private isConductPlaceholderName(name?: string | null): boolean {
    if (!name) return true;
    const trimmed = String(name).trim();
    if (!trimmed) return true;
    return (
      trimmed.startsWith('SuperSee User #') ||
      trimmed.startsWith('Conduct User') ||
      trimmed.startsWith('User #') ||
      trimmed === 'Unmapped User'
    );
  }

  private formatConductNameFromEmail(email: string): string {
    if (!email || !email.includes('@')) {
      return '';
    }
    const localPart = email.split('@')[0];
    if (!localPart) return '';

    const parts = localPart
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[._-]+/g, ' ')
      .replace(/\d+/g, '')
      .trim()
      .split(/\s+/);

    const capitalized = parts
      .filter(p => p.length > 0)
      .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
      .join(' ');

    return capitalized || localPart;
  }

  mapConductTimelogUser(log: any): any {
    const userId = log.supersee_user_id || log.supersee_user;
    let empName = log.original_employee_name ?? log.employee_name ?? '';
    let empEmail = log.employee_email || log.user_email || log.email || '';

    const loggedInUser = this.tokenEncryptionService?.getEncryptedItem<any>('logedInUser') || this.tokenEncryptionService?.getEncryptedItem<any>('user') || {};

    let foundUser: any = null;
    if (this.userList && this.userList.length > 0) {
      foundUser = this.userList.find((u: any) => {
        if (!u) return false;
        if (userId && (u.id == userId || u.ID == userId || u.userId == userId)) {
          return true;
        }
        if (empEmail && ((u.user_email && u.user_email.toLowerCase() === empEmail.toLowerCase()) || (u.email && u.email.toLowerCase() === empEmail.toLowerCase()))) {
          return true;
        }
        return false;
      });
      if (foundUser) {
        empName = foundUser.display_name || foundUser.name || (foundUser.first_name ? `${foundUser.first_name} ${foundUser.last_name || ''}`.trim() : '') || foundUser.user_email || `User #${userId}`;
        empEmail = foundUser.user_email || foundUser.email || empEmail;
      }
    }

    if ((!empName || this.isConductPlaceholderName(empName)) && loggedInUser) {
      const loggedInUserId = loggedInUser?.id || loggedInUser?.ID || loggedInUser?.userId;
      const loggedInEmail = (loggedInUser?.user_email || loggedInUser?.email || '').toLowerCase().trim();
      if ((loggedInUserId && String(userId) === String(loggedInUserId)) || (empEmail && loggedInEmail && empEmail.toLowerCase().trim() === loggedInEmail)) {
        empName = loggedInUser.display_name || loggedInUser.name || (loggedInUser.first_name ? `${loggedInUser.first_name} ${loggedInUser.last_name || ''}`.trim() : '') || loggedInUser.user_email || loggedInUser.email || `User #${userId}`;
        empEmail = loggedInUser.user_email || loggedInUser.email || empEmail;
      }
    }

    if (!empName || this.isConductPlaceholderName(empName)) {
      if (empEmail) {
        const fromEmail = this.formatConductNameFromEmail(empEmail);
        if (fromEmail) {
          empName = fromEmail;
        }
      }
    }

    if (!empName || this.isConductPlaceholderName(empName)) {
      if (userId) {
        empName = `SuperSee User #${userId}`;
      } else if (log.conduct_user_id) {
        empName = `Conduct User (${String(log.conduct_user_id).substring(0, 6)}...)`;
      } else {
        empName = 'Unmapped User';
      }
    }

    let workedHours = log.worked_hours || '';
    if (!workedHours && log.duration_time_second !== undefined && log.duration_time_second !== null) {
      const totalSecs = parseInt(log.duration_time_second, 10) || 0;
      const h = Math.floor(totalSecs / 3600);
      const m = Math.floor((totalSecs % 3600) / 60);
      const s = totalSecs % 60;
      workedHours = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }

    return {
      ...log,
      employee_name: empName,
      employee_email: empEmail,
      worked_hours: workedHours || '00:00:00',
      date: log.log_date || log.date || ''
    };
  }

  fetchConductTimelogs(isManual: boolean = false, startDateOverride?: string, endDateOverride?: string): void {
    this.isImportingConductTimelogs = true;
    this.groupedConductProjects = [];
    this.conductTimelogs = [];

    const user = this.tokenEncryptionService.getEncryptedItem<any>('user') || {};
    const companyId = user?.company_id || user?.id || user?.userId || 0;

    this._projectService.getConductIntegrationStatus(companyId).subscribe({
      next: (statusRes: any) => {
        if (!statusRes || !statusRes.is_integrated) {
          this.isConductIntegrated = false;
          this.isImportingConductTimelogs = false;
          this.cdr.detectChanges();
          console.log('[SUPERSEE ADMIN DASHBOARD] Conduct integration is not active. Skipping timelog fetch.');
          if (isManual) {
            swal.fire('Integration Required', 'Conduct integration is not active. Please integrate Conduct under Settings > Integrations.', 'info');
          }
          return;
        }

        this.isConductIntegrated = true;

        const targetDate = startDateOverride || (this.conductSelectedDate || moment()).format('YYYY-MM-DD');

        const handleLogsResponse = (rawLogs: any[]) => {
          let filteredLogs = rawLogs;
          if (this.userList && this.userList.length > 0) {
            const loggedInUser = this.tokenEncryptionService?.getEncryptedItem<any>('user') || {};
            const userRoles = Array.isArray(loggedInUser?.roles) ? loggedInUser.roles : [];
            const isCompanyAdmin = userRoles.includes('company') || loggedInUser?.role === 'company' || loggedInUser?.role === 'administrator';

            if (!isCompanyAdmin) {
              const allowedUserIds = new Set(this.userList.map((u: any) => String(u.id || u.ID || u.userId)));
              const loggedInUserId = loggedInUser?.id || loggedInUser?.userId;
              if (loggedInUserId) {
                allowedUserIds.add(String(loggedInUserId));
              }
              filteredLogs = rawLogs.filter((log: any) => {
                const uid = String(log.supersee_user_id || log.supersee_user || '');
                return uid && allowedUserIds.has(uid);
              });
            }
          }

          this.conductTimelogs = filteredLogs.map((log: any) => this.mapConductTimelogUser(log));
          this.groupedConductTimelogs = this.groupConductTimelogs(this.conductTimelogs);
          this.groupedConductProjects = this.groupConductProjects(this.conductTimelogs);
          this.isImportingConductTimelogs = false;
          this.cdr.detectChanges();
          console.log('[SUPERSEE ADMIN DASHBOARD] Mapped Conduct Timelogs & Grouped:', this.groupedConductTimelogs);
        };

        this._projectService.fetchConductTimelogs({
          supersee_company_id: companyId,
          requesting_user_id: user?.id,
          start_date: targetDate,
          end_date: targetDate
        }).subscribe({
          next: (res: any) => {
            const rawLogs = res?.timelogs || res?.data || (Array.isArray(res) ? res : []);
            if (rawLogs && rawLogs.length > 0) {
              handleLogsResponse(rawLogs);
            } else {
              // Fallback to fetch saved database timelogs for targetDate
              this._projectService.getSavedConductTimelogs(companyId, null, targetDate).subscribe({
                next: (savedRes: any) => {
                  const savedLogs = savedRes?.timelogs || savedRes?.data || (Array.isArray(savedRes) ? savedRes : []);
                  handleLogsResponse(savedLogs);
                },
                error: () => handleLogsResponse([])
              });
            }
          },
          error: (err: any) => {
            console.error('[SUPERSEE ADMIN DASHBOARD] Failed to fetch Conduct timelogs, checking saved database logs:', err);
            this._projectService.getSavedConductTimelogs(companyId, null, targetDate).subscribe({
              next: (savedRes: any) => {
                const savedLogs = savedRes?.timelogs || savedRes?.data || (Array.isArray(savedRes) ? savedRes : []);
                handleLogsResponse(savedLogs);
              },
              error: () => {
                this.isImportingConductTimelogs = false;
                this.cdr.detectChanges();
                if (isManual) {
                  swal.fire('Error!', err?.error?.message || 'Failed to fetch Conduct timelogs.', 'error');
                }
              }
            });
          }
        });
      },
      error: (err: any) => {
        this.isImportingConductTimelogs = false;
        this.cdr.detectChanges();
        console.log('[SUPERSEE ADMIN DASHBOARD] Conduct integration status check failed. Skipping timelog fetch.');
        if (isManual) {
          swal.fire('Error!', 'Failed to verify Conduct integration status.', 'error');
        }
      }
    });
  }

  ngOnInit() {
    this.fetchConductTimelogs();
    this.route.queryParams.subscribe(params => {
      let appUsageChanged = false;
      let webUsageChanged = false;
      let timelineChanged = false;

      // 1. Application Usage
      const appUsage = params['application-usage'];
      if (appUsage) {
        let startStr = '';
        let endStr = '';
        if (appUsage.includes('_')) {
          const parts = appUsage.split('_');
          if (parts.length === 2) {
            startStr = parts[0];
            endStr = parts[1];
          }
        } else {
          const parts = appUsage.split('-');
          if (parts.length === 6) {
            startStr = parts.slice(0, 3).join('-');
            endStr = parts.slice(3, 6).join('-');
          }
        }

        if (startStr && endStr) {
          const parsedStart = moment(startStr, 'YYYY-MM-DD');
          const parsedEnd = moment(endStr, 'YYYY-MM-DD');
          if (parsedStart.isValid() && parsedEnd.isValid()) {
            const minAllowedDate = moment(new Date(year, month, date)).subtract(90, 'days').startOf('day');

            if (parsedStart.isBefore(minAllowedDate) || parsedEnd.isAfter(moment(new Date(year, month, date)).add(1, 'days').endOf('day'))) {
              const fallbackDate = new Date(year, month, date);
              const fallbackStr = this.datePipe.transform(fallbackDate, "yyyy-MM-dd");
              this.startdate = fallbackDate;
              this.startDate = fallbackStr;
              this.enddate = fallbackDate;
              this.endDate = fallbackStr;
              appUsageChanged = true;

              setTimeout(() => {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    'application-usage': `${fallbackStr}_${fallbackStr}`
                  },
                  queryParamsHandling: 'merge'
                });
              });
            } else {
              const currentStartStr = this.startdate ? this.datePipe.transform(this.startdate, "yyyy-MM-dd") : '';
              const currentEndStr = this.enddate ? this.datePipe.transform(this.enddate, "yyyy-MM-dd") : '';
              if (currentStartStr !== startStr || currentEndStr !== endStr) {
                this.startdate = parsedStart.toDate();
                this.startDate = startStr;
                this.enddate = parsedEnd.toDate();
                this.endDate = endStr;
                appUsageChanged = true;
              }
            }
          }
        }
      }

      // 2. Website Usage
      const webUsage = params['website-usage'];
      if (webUsage) {
        let startStr = '';
        let endStr = '';
        if (webUsage.includes('_')) {
          const parts = webUsage.split('_');
          if (parts.length === 2) {
            startStr = parts[0];
            endStr = parts[1];
          }
        } else {
          const parts = webUsage.split('-');
          if (parts.length === 6) {
            startStr = parts.slice(0, 3).join('-');
            endStr = parts.slice(3, 6).join('-');
          }
        }

        if (startStr && endStr) {
          const parsedStart = moment(startStr, 'YYYY-MM-DD');
          const parsedEnd = moment(endStr, 'YYYY-MM-DD');
          if (parsedStart.isValid() && parsedEnd.isValid()) {
            const minAllowedDate = moment(new Date(year, month, date)).subtract(90, 'days').startOf('day');

            if (parsedStart.isBefore(minAllowedDate) || parsedEnd.isAfter(moment(new Date(year, month, date)).add(1, 'days').endOf('day'))) {
              const fallbackDate = new Date(year, month, date);
              const fallbackStr = this.datePipe.transform(fallbackDate, "yyyy-MM-dd");
              this.startDateForInput = fallbackDate;
              this.startDateWebsiteUsageChart = fallbackStr;
              this.endDateForInput = new Date(year, month, date, 23, 59, 59);
              this.endDateWebsiteUsageChart = fallbackStr;
              webUsageChanged = true;

              setTimeout(() => {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    'website-usage': `${fallbackStr}_${fallbackStr}`
                  },
                  queryParamsHandling: 'merge'
                });
              });
            } else {
              const currentStartWebStr = this.startDateForInput ? this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd") : '';
              const currentEndWebStr = this.endDateForInput ? this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd") : '';
              if (currentStartWebStr !== startStr || currentEndWebStr !== endStr) {
                this.startDateForInput = parsedStart.toDate();
                this.startDateWebsiteUsageChart = startStr;
                this.endDateForInput = parsedEnd.toDate();
                this.endDateWebsiteUsageChart = endStr;
                webUsageChanged = true;
              }
            }
          }
        }
      }

      // 3. Timeline Mode (24h vs 48h)
      const timelineMode = params['timeline-mode'];
      if (timelineMode) {
        const is24 = timelineMode === '24h';
        if (this.isSingleDayActive !== is24) {
          this.isSingleDayActive = is24;
          this.isVirtualShiftActive = !is24;
          this.x_min = 0;
          this.x_max = is24 ? 24 : 47.59;
          timelineChanged = true;
        }
      }

      // 4. Timeline Date
      const timelineDate = params['timeline-date'];
      if (timelineDate) {
        if (timelineDate.includes('_')) {
          const parts = timelineDate.split('_');
          if (parts.length === 2) {
            const startMom = moment(parts[0], 'YYYY-MM-DD');
            const endMom = moment(parts[1], 'YYYY-MM-DD');
            if (startMom.isValid() && endMom.isValid()) {
              const minAllowedDate = moment(new Date(year, month, date)).subtract(90, 'days').startOf('day');

              if (startMom.isBefore(minAllowedDate) || endMom.isAfter(moment(new Date(year, month, date)).add(1, 'days').endOf('day'))) {
                const fallbackStart = moment(new Date(year, month, date)).subtract(1, 'days').startOf('day');
                const fallbackEnd = moment(new Date(year, month, date)).subtract(1, 'days').endOf('day');
                this.timelineSelectedDate = { startDate: fallbackStart, endDate: fallbackEnd };
                timelineChanged = true;

                setTimeout(() => {
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                      'timeline-date': `${fallbackStart.format('YYYY-MM-DD')}_${fallbackEnd.format('YYYY-MM-DD')}`
                    },
                    queryParamsHandling: 'merge'
                  });
                });
              } else {
                const start = startMom.startOf('day');
                const end = endMom.endOf('day');
                if (!this.timelineSelectedDate || !this.timelineSelectedDate.startDate || !this.timelineSelectedDate.startDate.isSame(start, 'day') || !this.timelineSelectedDate.endDate.isSame(end, 'day')) {
                  this.timelineSelectedDate = { startDate: start, endDate: end };
                  timelineChanged = true;
                }
              }
            }
          }
        } else {
          const parsed = moment(timelineDate, 'YYYY-MM-DD');
          if (parsed.isValid()) {
            const minAllowedDate = moment(new Date(year, month, date)).subtract(90, 'days').startOf('day');

            if (parsed.isBefore(minAllowedDate) || parsed.isAfter(moment(new Date(year, month, date)).add(1, 'days').endOf('day'))) {
              const fallbackDate = moment(new Date(year, month, date));
              const start = fallbackDate.clone().startOf('day');
              const end = fallbackDate.clone().endOf('day');
              this.timelineSelectedDate = { startDate: start, endDate: end };
              timelineChanged = true;

              setTimeout(() => {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    'timeline-date': fallbackDate.format('YYYY-MM-DD')
                  },
                  queryParamsHandling: 'merge'
                });
              });
            } else {
              const start = parsed.clone().startOf('day');
              const end = parsed.clone().endOf('day');
              if (!this.timelineSelectedDate || !this.timelineSelectedDate.startDate || !this.timelineSelectedDate.startDate.isSame(start, 'day') || !this.timelineSelectedDate.endDate.isSame(end, 'day')) {
                this.timelineSelectedDate = { startDate: start, endDate: end };
                timelineChanged = true;
              }
            }
          }
        }
      }

      // Sync datepicker input models
      if (this.timelineSelectedDate) {
        this.syncTimelineSingleDayModelFromMoments();
        this.patchTimeline48RangeFromMoments();
      }

      // 5. Timeline Shift Selection
      const timelineShift = params['timeline-shift'];
      if (timelineShift && timelineShift.includes('_')) {
        const parts = timelineShift.split('_');
        if (parts.length === 2) {
          if (this.timelineStartTime !== parts[0] || this.timelineEndTime !== parts[1]) {
            this.timelineStartTime = parts[0];
            this.timelineEndTime = parts[1];
            timelineChanged = true;
          }
        }
      } else if (timelineShift !== undefined && (this.timelineStartTime !== null || this.timelineEndTime !== null)) {
        // Only clear if param was explicitly set (not just absent from URL)
        this.timelineStartTime = null;
        this.timelineEndTime = null;
        timelineChanged = true;
      }

      // 6. Timeline Team Selection
      const timelineTeam = params['timeline-team'];
      if (timelineTeam !== undefined) {
        if (!timelineTeam) {
          if (this.selectedTeam !== '') {
            this.applyTeamFilterCore(null);
            timelineChanged = true;
          }
        } else if (this.teamsListForFilter && this.teamsListForFilter.length > 0) {
          const teamId = parseInt(timelineTeam, 10);
          const teamObj = this.teamsListForFilter.find(t => t.id === teamId);
          if (teamObj && this.selectedTeam !== teamObj.title.rendered) {
            this.applyTeamFilterCore(teamObj);
            timelineChanged = true;
          }
        }
      }

      // 7. Timeline Search Filter
      const timelineSearch = params['timeline-search'];
      if (timelineSearch !== undefined) {
        if (this.searchStack !== timelineSearch) {
          this.searchStack = timelineSearch || '';
          timelineChanged = true;
        }
      }

      // 8. Timeline Pagination Page
      const timelinePage = params['timeline-page'];
      if (timelinePage) {
        const parsedPage = parseInt(timelinePage, 10);
        if (!isNaN(parsedPage) && parsedPage > 0 && parsedPage !== this.page) {
          this.page = parsedPage;
          // startPage / endPage will be recalculated by the API response
        }
      }

      // Trigger specific API calls depending on what actually changed
      if (appUsageChanged && this.userList && this.userList.length > 0) {
        this.getTotalHour(
          this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
          this.datePipe.transform(this.enddate, "yyyy-MM-dd")
        );
        this.getPieChartData(
          this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
          this.datePipe.transform(this.enddate, "yyyy-MM-dd")
        );
      }

      if (webUsageChanged && this.userList && this.userList.length > 0) {
        this.getWebsiteUsageChartData(
          this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd"),
          this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd")
        );
      }

      if (timelineChanged && this.userList && this.userList.length > 0) {
        // Reset pagination to page 1 when any timeline filter changes
        this.resetTimelinePagination();
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { 'timeline-page': null },
          queryParamsHandling: 'merge'
        });
        this.filterTeam();
      }
    });

    document.getElementById("pieChartContainer")
      ? document.getElementById("pieChartContainer").remove()
      : "";
    document.getElementById("chartContainer")
      ? document.getElementById("chartContainer").remove()
      : "";

    document.getElementById("donutChartNewContainer")
      ? document.getElementById("donutChartNewContainer").remove()
      : "";
    document.getElementById("chartContainer2")
      ? document.getElementById("chartContainer2").remove()
      : "";

    this._sharedServices.isOpenCloseSidebar.next({ force: true });
    this.isAdmin = JSON.parse(localStorage.getItem('isAdmin')) || false
    this.getUser();
    this._messagingService.showNotification();

    const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id;
    this.screenshotTime.getShiftTimezoneForCompany(companyId).subscribe((tz) => {
      this.shiftTimezone = tz;
      this.regionHint = this.screenshotTime.getScreenshotsRegionHint(tz);
    });

    this.prefillTimelineShiftFromCompanySettings(companyId);

    // Setup banner: react to onboarding state/eligibility changes
    this.onboardingService.state$.subscribe((state) => this.updateSetupBannerVisibility(state));
    this.onboardingService.eligible$.subscribe(() => this.updateSetupBannerVisibility());
    // Initial compute
    this.updateSetupBannerVisibility();
    this.demoOptInRefreshSub = this._sharedServices.dashboardDemoOptInRefresh$.subscribe(() => {
      this.getUserList();
    });
    this.setTimeRangeForDateInputs();
    this._sharedServices.dashboardScroller().subscribe((result: any) => {
      if (result == 'ss_section') {
        this.timelineSection = false;
        this.screenshotSection = true;
        this.timelineBackground = '';
        this.screenshotBackground = 'timeline-section-btn-bg-color';
        this.scroller.scrollToAnchor('timeline_ss_section');
      } else if (result == 'timeline_section') {
        this.timelineSection = true;
        this.screenshotSection = false;
        this.timelineBackground = 'timeline-section-btn-bg-color';
        this.screenshotBackground = '';
        this.scroller.scrollToAnchor('timeline_ss_section');
      } else {
        this.scroller.scrollToAnchor(result);
      }
    });

    this.employeeMultiCtrl.valueChanges.subscribe(() => {
      this.getLastScreenshots();
    });

    this._sharedServices.dashboardScroller().subscribe((result: any) => {
      if (result == 'ss_section') {
        this.timelineSection = false;
        this.screenshotSection = true;
        this.timelineBackground = '';
        this.screenshotBackground = 'timeline-section-btn-bg-color';
        this.scroller.scrollToAnchor('timeline_ss_section');
      } else if (result == 'timeline_section') {
        this.timelineSection = true;
        this.screenshotSection = false;
        this.timelineBackground = 'timeline-section-btn-bg-color';
        this.screenshotBackground = '';
        this.scroller.scrollToAnchor('timeline_ss_section');
      } else {
        this.scroller.scrollToAnchor(result);
      }
    });

    this._projectService.dashboardTourActive.subscribe((value: any) => {
      // Calls previously here are now moved outside/above
      // Ensure timeline/screenshot sections are still toggled if needed by the tour logic
      this.timelineSection = true;
      this.screenshotSection = false;
      // If the tour requires reloading specific data upon activation, those calls might need to be added back here conditionally.
      // For now, assuming initial load covers it.
    });

    this.patchScreenshotDateRangeFromMoments();
    this.patchTimeline48RangeFromMoments();
    this.syncTimelineSingleDayModelFromMoments();
  }

  ngAfterViewInit() {
    // Keep these calls here for now
    this.getTotalOnlineOflineData();
    this.getUserList(); // This will now primarily fetch the list and set up real-time updates
    this.getLastScreenshots();
  }

  loadChartsAfterUserCheck() {
    // Initial data loading - Called after user check is complete
    this.getTotalHour(
      this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
      this.datePipe.transform(this.enddate, "yyyy-MM-dd")
    );
    this.getPieChartData(
      this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
      this.datePipe.transform(this.enddate, "yyyy-MM-dd")
    );
    this.getWebsiteUsageChartData(
      this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd"),
      this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd")
    );



    if (this.isTourActive()) {
      this._projectService.getTeamList().subscribe(
        (team: any) => {
          this.loading = false;
          // If we are already showing demo users, keep teams consistent by using demo teams as well
          if (this.isShowingDemoData) {
            this.teamsListForFilter = this._dummyDataService.getDataByParams<Team[]>('TeamList').data;
          } else {
            this.teamsListForFilter = team || [];
          }
          this.teamSize = Array.isArray(this.teamsListForFilter) ? this.teamsListForFilter.length : 0;

          const urlTeam = this.route.snapshot.queryParams['timeline-team'];
          if (urlTeam) {
            const teamId = parseInt(urlTeam, 10);
            const teamObj = this.teamsListForFilter.find(t => t.id === teamId);
            if (teamObj) {
              this.applyTeamFilterCore(teamObj);
            }
          }

          this.cdr.detectChanges();
        },
        (err) => {
          // Do not fallback in API mode; simply keep current value
          this.loading = false;
          this.cdr.detectChanges();
        }
      );
    } else {
      // Demo mode: use demo teams exclusively
      this.teamsListForFilter = this._dummyDataService.getDataByParams<Team[]>('TeamList').data;
      this.teamSize = Array.isArray(this.teamsListForFilter) ? this.teamsListForFilter.length : 0;

      const urlTeam = this.route.snapshot.queryParams['timeline-team'];
      if (urlTeam) {
        const teamId = parseInt(urlTeam, 10);
        const teamObj = this.teamsListForFilter.find(t => t.id === teamId);
        if (teamObj) {
          this.applyTeamFilterCore(teamObj);
        }
      }

      this.cdr.detectChanges();
    }

    this.employeeMultiCtrl.valueChanges.subscribe(() => {
      this.getLastScreenshots();
    });

    this._sharedServices.dashboardScroller().subscribe((result: any) => {
      if (result == 'ss_section') {
        this.timelineSection = false;
        this.screenshotSection = true;
        this.timelineBackground = '';
        this.screenshotBackground = 'timeline-section-btn-bg-color';
        this.scroller.scrollToAnchor(result);
      } else if (result == 'timeline_section') {
        this.timelineSection = true;
        this.screenshotSection = false;
        this.timelineBackground = 'timeline-section-btn-bg-color';
        this.screenshotBackground = '';
        this.scroller.scrollToAnchor(result);
      } else {
        this.scroller.scrollToAnchor(result);
      }
    });

    this._projectService.dashboardTourActive.subscribe((value: any) => {
      // Calls previously here are now moved outside/above
      // Ensure timeline/screenshot sections are still toggled if needed by the tour logic
      this.timelineSection = true;
      this.screenshotSection = false;
      // If the tour requires reloading specific data upon activation, those calls might need to be added back here conditionally.
      // For now, assuming initial load covers it.
    })
  }

  private loadCharts() {
    this.getPieChartData(
      this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
      this.datePipe.transform(this.enddate, "yyyy-MM-dd")
    );

    this.getWebsiteUsageChartData(
      this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd"),
      this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd")
    )
  }

  getUser() {
    this._projectService.getUser().subscribe((data: any) => {


      let roleArr = [];

      roleArr = data.role;
      this.isAdmin = hasCompanyRole(data);
      this.isPaid = data.meta.quota_status === 'active' || data.meta.quota_status === 'Active';

      let managerRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("manager"));
      })
      if (managerRole.length == 0) {
        this.isManager = false;
      } else {
        this.isManager = true;
      }

      let leadRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("lead"));
      })
      if (leadRole.length == 0) {
        this.isTeamLead = false;
      } else {
        this.isTeamLead = true;
      }

      this.tokenEncryptionService.setEncryptedItem('user', data);
      let isExpired = this._sharedServices.checkPlanExpired(data)
      if (isExpired) {
        this.router.navigateByUrl('/plan-expired');
      }
      this.updateSetupBannerVisibility();
    })
  }

  /**
   * Sample/demo dashboard data only after explicit opt-in (banner / Help).
   */
  /**
   * Template helper for dashboard cards/filters: returns false while ngx guided tour is active (`isTour` === 'true').
   * (Legacy name kept for HTML bindings.)
   */
  isTourActive(): boolean {
    return localStorage.getItem('isTour') !== 'true';
  }

  tryDemoData(): void {
    const currentState = this.trialOnboardingHelp.isShowingDemoData();
    trackClarityEvent('activation_dashboard_demo_toggled', {
      phase: this.setupBannerPhase,
      action: currentState ? 'hide' : 'preview'
    });
    this.trialOnboardingHelp.tryDemoData(!currentState);
  }

  takeProductTour(): void {
    this.trialOnboardingHelp.startProductTour();
  }

  private getRealQuotaAllowedCount(): number {
    if (this.demoEnvironment.isDemoRealm()) {
      const headcount =
        this.allUsersCount ||
        (Array.isArray(this.userList) ? this.userList.length : 0);
      if (headcount > 0) {
        return headcount;
      }
      const active = this.demoEnvironment.getActivePersonaFromSession();
      if (active?.seededEmployeeCount) {
        return active.seededEmployeeCount;
      }
    }

    const currentUser =
      this.tokenEncryptionService.getEncryptedItem<any>('user') ||
      this.tokenEncryptionService.getEncryptedItem<any>('logedInUser');
    const rawQuota = currentUser?.meta?.quota_allowed;
    const parsedQuota = Number(rawQuota);
    return Number.isFinite(parsedQuota) ? parsedQuota : 0;
  }

  filterStates(name: string) {
    if (name) this.userName = "";

    return this.users.filter(
      (state) =>
        state._id != null &&
        state.name &&
        state.name.toLowerCase().includes(name.toLowerCase().trim())
    );
  }
  onEnter(evt: any, name) {
    if (this.users.includes(name)) return;
    if (evt != null) {
      this.userId = evt;
    }
    this.userName = name;
    this.users.push(name);
    this.stateInput.nativeElement.value = "";
    this.filterControl.setValue(null);
    this.removable = true;
  }

  onKeyUp() {
    this.userName = "";
  }

  displayFn(option) {
    if (option && option != undefined) {
      return option;
    }
  }

  onCardClick(type: any) {
    switch (type) {
      case "total":
        localStorage.setItem("empCount", JSON.stringify(this.totalUsers));
        this._projectService.empCountSubject.next(this.totalUsers);
        break;
      case "online":
        localStorage.setItem("empCount", JSON.stringify(this.onlineUsers));
        this._projectService.empCountSubject.next(this.onlineUsers);
        break;
      case "offline":
        localStorage.setItem("empCount", JSON.stringify(this.offlineUsers));
        this._projectService.empCountSubject.next(this.offlineUsers);
        break;
    }
  }

  getUserList() {
    this._isTotalHoursLoading = true
    this._isStackbarLoading = true
    this._isAppUsageLoading = true
    this.isloading = true;
    this.userDataSubscription?.unsubscribe();
    this.userDataSubscription = null;

    if (this.isTourActive()) {
      this._projectService.getUserList(0, 0).subscribe(async (user: any) => {
        const isShowDemoData = await this._dummyDataService.checkIsAvailableDemoData<Employee[]>('EmployeeList');
        if (this._sharedServices.checkUserIsUseDummyData(isShowDemoData, user)) {
          // Use demo users and mark them online by default — only when the account has no real users.
          this.userList = isShowDemoData.data;
          this.filterUsers = this.userList;

          // Populate online/offline counts and lists for demo users
          this.onlineUsers = this.userList.length;
          this.offlineUsers = 0;
          this.allUsersCount = this.userList.length;
          this.quotaAllowedToCreateUser = this.allUsersCount;
          this.onlineUsersForCard = this.userList;
          this.onlineEmployee = this.userList.map((wpEmployee: any) => ({ wpEmployee, fbEmployee: null }));
          this.offlineEmployee = [];
          // Set demo flag so other widgets (like Teams count) stay consistent
          this.isShowingDemoData = true;
          this._dummyDataService.setDemoDataVisible(true);
          console.log('Demo data detected');

          // Update percentages/badges based on new counts
          this.getTotalOnlineOflineData();

          this.loading = false;
          this.isloading = false;

          // Load charts after setting demo data flag
          this.loadChartsAfterUserCheck();

          // Load dummy screenshots for demo mode
          this.getLastScreenshots();

          // No realtime source for dummy users; skip subscription below
        } else {
          this.userList = user;
          if (this.conductTimelogs && this.conductTimelogs.length > 0) {
            this.conductTimelogs = this.conductTimelogs.map(log => this.mapConductTimelogUser(log));
            this.groupedConductTimelogs = this.groupConductTimelogs(this.conductTimelogs);
            this.groupedConductProjects = this.groupConductProjects(this.conductTimelogs);
          }
          if (this.timelineConductTimelogs && this.timelineConductTimelogs.length > 0) {
            this.timelineConductTimelogs = this.timelineConductTimelogs.map(log => this.mapConductTimelogUser(log));
          }
          this.filterUsers = this.userList;
          this.isShowingDemoData = false;
          this._dummyDataService.setDemoDataVisible(false);
          if (Array.isArray(user) && user.length > 0) {
            this.trialOnboardingHelp.clearStaleSampleOptIn({ hasRealEmployeeData: true });
          }
          this.onlineUsersForCard = [];
          this.offlineUsersForCard = [];
          this.idleUsersForCard = [];
          this.onlineEmployee = [];
          this.offlineEmployee = [];
          this.idleEmployee = [];
          this.allUsersCount = Array.isArray(this.userList) ? this.userList.length : 0;
          this.quotaAllowedToCreateUser = this.getRealQuotaAllowedCount();
          this.loading = false;
          this.isloading = false;
          // Demo banner removed

          // Load charts after setting real data flag
          this.loadChartsAfterUserCheck();
        }

        // Check if query parameters specify the timeline configuration, otherwise fallback to local storage
        if (this.route.snapshot.queryParams['timeline-date']) {
          this.filterTeam();
        } else {
          const ss_timeline_filter_start_time = localStorage.getItem('ss_timeline_filter_start_time');
          const supersee_timiline_filter_end_time = localStorage.getItem('supersee_timiline_filter_end_time');

          if (ss_timeline_filter_start_time && supersee_timiline_filter_end_time) {
            this.timelineSelectedDate = {
              startDate: moment(ss_timeline_filter_start_time),
              endDate: moment(supersee_timiline_filter_end_time)
            };
            this.syncTimelineSingleDayModelFromMoments();
            this.patchTimeline48RangeFromMoments();

            const diffHours = this.timelineSelectedDate.endDate.diff(this.timelineSelectedDate.startDate, 'hours');
            if (diffHours > 24) {
              this.isSingleDayActive = false;
              this.isVirtualShiftActive = true;
              this.x_min = 0;
              this.x_max = 47.59;
              this.getStackedChartDataForVirtualShift(ss_timeline_filter_start_time, this.searchStack, supersee_timiline_filter_end_time);
            } else {
              this.isSingleDayActive = true;
              this.isVirtualShiftActive = false;
              this.x_min = 0;
              this.x_max = 24;
              this.getStackedChartData(ss_timeline_filter_start_time, this.searchStack, supersee_timiline_filter_end_time);
            }
          } else {
            this.filterTeam();
          }
        }

        // Real-time updates remain dependent on userList
        if (!(!user || user.length === 0)) {
          // We get from the firebase what we get in this list
          // [Offline, Online, Idle, Auto-logout] <- from the firebase in below subscribe
          this.userDataSubscription = this._messagingService.getUserData().subscribe((users) => {
            let online = 0;
            let offline = 0;
            let idle = 0;
            let onlineUsers: any = []
            let offlineUsers: any = []
            let idleUsers: any = []
            if (this.userList && this.userList.length > 0) {
              // This user list contains all the users we get from wordpress all users list <- it contains all status users [Offline, Online, Idle, Auto-logout, Invited]

              // First step : we get all users and pack in allUsers Array
              this.allUsersCount = this.userList.length;

              // Log company quota info
              this.quotaAllowedToCreateUser = this._sharedServices.checkUserIsUseDummyData(isShowDemoData, user)
                ? this.userList?.length
                : this.getRealQuotaAllowedCount();

              // Now we get only invited users list
              // How we get total users - firebase users
              this.invitedUsersList = this.userList.filter((wpUser) => !users.find((fbUser) => fbUser?.id == wpUser?.id))

              // Now we get only absent users
              // first we remove invited users
              const removedInvitedUser = users.map((fbUser) => {
                if (this.userList.find((wpUser) => fbUser.id == wpUser.id)) {
                  return { fbUser, wpUser: this.userList.find((wpUser) => fbUser?.id == wpUser?.id) }
                }
              });

              // get online user with their time key
              const onlineUsersFiltered = removedInvitedUser.filter((user) => this._sharedServices.getUserCurrentStatus(user?.fbUser?.lastOnlineAtTz, true) == "online" && !user?.fbUser?.isIdle)
              if (onlineUsersFiltered.length > 0) {
                this.onlineUsersForCard = onlineUsersFiltered.map((onlineUser) => onlineUser.wpUser);
              }

              let idleUsersList: any = [];
              for (let i = 0; i < removedInvitedUser.length; i++) {
                if (removedInvitedUser[i]?.fbUser && removedInvitedUser[i]?.fbUser?.isIdle) {
                  if (this._sharedServices.getUserCurrentStatus(removedInvitedUser[i]?.fbUser?.lastOnlineAtTz, true) == "online") {
                    idleUsersList.push(removedInvitedUser[i]);
                  }
                }
              }

              // get idle user with their idle key and they not logout due to auto logout                
              if (idleUsersList.length > 0) {
                this.idleUsersForCard = idleUsersList.map((onlineUser) => onlineUser.wpUser);
              }

              // first check user have not logout due to auto logout
              // check if user is not idle
              // and then check user is not online more than one day
              const checkUsersAbsentRecords = removedInvitedUser.filter((user) => {
                if (user) {
                  // Get those who auto logged out in past and not logged out 
                  let logoutReasonUsersBehindOfOnlineTime = this.checkUserIsAutoLogout(user?.fbUser);
                  let checkLastOnlineAtTime = this._sharedServices.getDayDifferenceForAbsent(user?.fbUser?.lastOnlineAtTz);
                  let checkUserIsInIdleList = this.idleUsersForCard.find((idleUser) => idleUser?.id == user?.wpUser?.id)
                  if (!logoutReasonUsersBehindOfOnlineTime && !checkUserIsInIdleList && checkLastOnlineAtTime > 0) {
                    return user.wpUser
                  }
                }
              });
              if (checkUsersAbsentRecords.length > 0) {
                this.absentUsersList = checkUsersAbsentRecords.map((absentUser) => absentUser.wpUser);
              }


              const offlineUsersFiltered = removedInvitedUser.filter((user) => {
                // first its not in absent list
                // user is not in idle
                // user not in online status
                if (!this.absentUsersList.find((absentUser) => absentUser?.id == user?.wpUser?.id) && !this.onlineUsersForCard.find((onlineUser) => onlineUser?.id == user?.wpUser?.id) && !this.idleUsersForCard.find((idleUser) => idleUser?.id == user?.wpUser?.id)) {
                  return user
                }
              });
              if (offlineUsersFiltered.length > 0) {
                this.offlineUsersForCard = offlineUsersFiltered.map((offlineUser) => offlineUser.wpUser);
              }

              this.userList.forEach((wpEmployee: any) => {
                const index = _.findIndex(users, function (fbEmployee: any) { return fbEmployee.id == wpEmployee.id; });
                if (index > -1) {
                  // Check for idle status first
                  if (users[index].isIdle === true && !users[index].logoutReason) {
                    idleUsers.push({ wpEmployee: wpEmployee, fbEmployee: users[index] })
                    idle++
                  } else if (users[index].lastOnlineAtTz) {
                    const currentStatus = this._sharedServices.getUserCurrentStatus(users[index].lastOnlineAtTz, true)
                    if (currentStatus == 'online') {
                      onlineUsers.push({ wpEmployee: wpEmployee, fbEmployee: users[index] })
                      online++
                    }
                    else {
                      offlineUsers.push({ wpEmployee: wpEmployee, fbEmployee: users[index] })
                      offline++
                    }
                  } else {
                    if (users[index].lastOnlineAt) {
                      const currentStatus = this._sharedServices.getUserCurrentStatus(users[index].lastOnlineAt, false)
                      if (currentStatus == 'online') {
                        onlineUsers.push({ wpEmployee: wpEmployee, fbEmployee: users[index] })
                        online++
                      }
                      else {
                        offlineUsers.push({ wpEmployee: wpEmployee, fbEmployee: users[index] })
                        offline++
                      }
                    }
                  }
                } else {
                  offline++
                  offlineUsers.push({ wpEmployee: wpEmployee, fbEmployee: null })
                }
              })

              if (this.onlineUsers != online || this.offlineUsers != offline || this.idleUsers != idle) {
                this.getTotalOnlineOflineData();
              }
              this.offlineUsers = offline
              this.onlineUsers = online
              this.idleUsers = idle
              this.offlineEmployee = offlineUsers
              this.onlineEmployee = onlineUsers
              this.idleEmployee = idleUsers
            }

            this.loading = false;
            this.isloading = false;

          }, err => {
            this.isloading = false;
          });
        }
        this.page = 1;
      }, (err: any) => {
        console.error('Error fetching user list:', err);
        this.loading = false;
        this.isloading = false;
      });
    } else {
      this.loading = false;
      this.isloading = false;
      this.page = 1;
      // Keep this call for the non-tour case if it's still needed here
      // Review if this should also be moved to ngAfterViewInit for consistency
      this.getStackedChartData(
        this.datePipe.transform(this.enddate, "yyyy-MM-dd"), this.searchStack
      );
    }
  }

  getAll(): AngularFireList<User> {
    return this.usersRef;
  }


  getLastScreenshots() {
    if (this.isTourActive()) {
      this.isloading = true;
      this.PhotoList = [];

      // Check if we're showing demo data and generate dummy screenshots
      if (this.isShowingDemoData) {
        this.generateDummyScreenshots();
        this.isloading = false;
        return;
      }

      const selectedEmployee = this.employeeMultiCtrl.value;
      let startDate: string | null = null;
      let endDate: string | null = null;
      if (this.selectedDateAndTime?.startDate && this.selectedDateAndTime?.endDate) {
        const bounds = this.screenshotTime.filterBoundsForApi(
          this.selectedDateAndTime.startDate,
          this.selectedDateAndTime.endDate,
          this.shiftTimezone
        );
        startDate = bounds.start;
        endDate = bounds.end;
      }

      this._projectService
        .getlastFifteenPhoto(selectedEmployee, this.pageSize, 0, this.currentPage, startDate, endDate)
        .subscribe(
          (res: HttpResponse<any>) => {


            this.total_ss = res.body.pagination.total_images || 0;
            let photos = this.getCorrectData(res.body.data);
            this.PhotoList = photos;
            this.isloading = false;

            setTimeout(() => {
              const targetElement = document.getElementById('ss_section');
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 100);

          },
          (err) => {
            console.error("Error fetching screenshots:", err);
            this.isloading = false;
          }
        );
    }
  }

  onEmployeeSelected(employeeId: string | number): void {
    this.employeeMultiCtrl.setValue(employeeId);
    this.getLastScreenshots();
  }

  displayUserName(id) {
    let resData = this.userList.filter((data: any) => {
      let userNameArr = data.name.split(" ");
      for (let i = 0; i < userNameArr.length; i++) {
        userNameArr[i] = userNameArr[i].charAt(0).toUpperCase() + userNameArr[i].slice(1);
      }
      data.name = userNameArr.join(" ");
      return data.id == id;
    });
    return resData.length ? resData[0].name : "";
  }

  imageNameAndDate(image, type) {
    return this._sharedServices.imageNameAndDate(image, type);
  }

  getFileName(ss) {
    if (ss.path) ss = ss.path;
    return ss.split("/")[1];
  }

  getDispplaySecond(second) {
    return parseInt(second);
  }

  getSelectedOptions(selected) {
    this.selected = selected;
  }

  getUserId(image) {
    const userId = image.split("/")[0];
    return userId;
  }

  onKey(value) {
    this.userList = this.filterUsers;

    this.userList = this.search(value);

  }

  search(value: string) {
    let filter = value.toLowerCase();

    return this.userList.filter((option) =>
      option.name.toLowerCase().includes(filter)
    );
  }
  onStackDateChange(event) {
    let date = event.value;
    this.stackDate = this.datePipe.transform(date, "yyyy-MM-dd");
    this.page = 1;
    this.filterTeam()
  }

  stackDatePrevNextAction(prev) {
    this.page = 1;
    if (prev) {
      this.stackDate = new Date(
        new Date(this.stackDate).getFullYear(),
        new Date(this.stackDate).getMonth(),
        new Date(this.stackDate).getDate() - 1
      );
      this.filterTeam()
    } else {
      this.stackDate = new Date(
        new Date(this.stackDate).getFullYear(),
        new Date(this.stackDate).getMonth(),
        new Date(this.stackDate).getDate() + 1
      );
      this.filterTeam()
    }
  }
  onStartDateChange(event) {
    let date = event.value;
    this.startdate = date;
    this.startDate = this.datePipe.transform(date, "yyyy-MM-dd");
    this.endDate = null;
    this.enddate = null;
  }

  onEndDateChange(event) {
    const endValue = event.value;
    this.enddate = endValue;
    this.endDate = this.datePipe.transform(event.value, "yyyy-MM-dd");
    if (this.startDate && this.endDate) {
      this.workingHours = null;
      this.appUsageHours = null;

      this.startDate = this.startDate ? this.datePipe.transform(this.startDate, "yyyy-MM-dd") : this.datePipe.transform(this.startdate, "yyyy-MM-dd");
      this.endDate = this.endDate ? this.endDate : this.datePipe.transform(this.enddate, "yyyy-MM-dd");

      this.getPieChartData(this.startDate, this.endDate);

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'application-usage': `${this.startDate}_${this.endDate}`
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  onStartDateChangeWebsiteUsageChart(event: any) {
    let date = event.value;
    this.startDateForInput = date;
    this.startDateWebsiteUsageChart = this.datePipe.transform(date, "yyyy-MM-dd");
    this.endDateWebsiteUsageChart = null;
    this.endDateForInput = null;
  }

  onEndDateChangeWebsiteUsageChart(event: any) {
    const endValue = event.value;
    this.endDateForInput = endValue;
    this.endDateWebsiteUsageChart = this.datePipe.transform(event.value, "yyyy-MM-dd");
    if (this.startDateWebsiteUsageChart && this.endDateWebsiteUsageChart) {
      this.workingHours = null;
      this.appUsageHours = null;
      this.startDateWebsiteUsageChart = this.startDateWebsiteUsageChart ? this.datePipe.transform(this.startDateWebsiteUsageChart, "yyyy-MM-dd") : this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd");
      this.endDateWebsiteUsageChart = this.endDateWebsiteUsageChart ? this.endDateWebsiteUsageChart : this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd");

      this.getWebsiteUsageChartData(this.startDateWebsiteUsageChart, this.endDateWebsiteUsageChart);

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'website-usage': `${this.startDateWebsiteUsageChart}_${this.endDateWebsiteUsageChart}`
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  onStartDateChange_ss(event) {
    let date = event.value;
    this.startdate_ss = this.datePipe.transform(date, "yyyy-MM-dd");
  }

  onEndDateChange_ss(event) {
    this.enddate_ss = this.datePipe.transform(event.value, "yyyy-MM-dd");
    if (this.startdate_ss && this.enddate_ss) {

      if (this.EmpPaginator) {
        this.EmpPaginator.firstPage()
      }
      this.offset = 0;
      this.currentPage = 1;
      this.getLastScreenshots();

    }
  }

  getTotalHour(start, end) {
    this.donutChartData = []
    this._isTotalHoursLoading = true

    if (this.isShowingDemoData) {
      // Mock data for demo mode
      this.donutChartData = ["02:15:00", "06:45:00"];
      this.donutChartLabel = ["Idle", "Productive"];
      this._isTotalHoursLoading = false;
      return;
    }

    this._projectService.getWorkinHourV2(start, end, this.selectedEmp).subscribe(
      (user: any) => {
        this.donutChartData = []
        let data;

        let ideal = [];
        let total = [];
        let productive = [];
        let label = ["Idle", "Productive",]
        let display = []
        for (let key in user) {
          ideal.push(user[key].idle);
          productive.push(user[key].productive);
        }
        data = {
          idle_time: this.addTimes(ideal) ? this.addTimes(ideal) : "00:00:00",
          productive_time: this.addTimes(productive)
            ? this.addTimes(productive)
            : "00:00:00",
        };

        this.donutChartData.push(data.idle_time)
        this.donutChartData.push(data.productive_time)

        this.donutChartLabel = label
        this._isTotalHoursLoading = false
      },
      (err) => {
        this.donutChartData = [];
        this._isTotalHoursLoading = false
        this._projectService.updateDonutChartData({ data: undefined });
      }
    );
  }

  async getPieChartData(start, end) {
    this.isPiechartLoad = true;

    // Prioritize demo data if enabled
    if (this.isShowingDemoData) {
      const demoRes = this._dummyDataService.getDataByParams<ApplicationUsage>('ApplicationUsage').data;
      let data = [];
      let label = [];
      let display = [];
      const chartData = this.getApplicationUsageData(demoRes)
      chartData.forEach((item) => {
        label.push(item.appName);
        data.push(item.usageTime);
        display.push(item);
      })
      this.isPiechartLoad = false;
      this._projectService.updateApplicationUsageData({ data: data, label: label, display: display, start_date: this.datePipe.transform(start, "yyyy-MM-dd"), end_date: this.datePipe.transform(end, "yyyy-MM-dd") })
      this.pieChartData = data;
      this.pieChartLabel = label;
      this.pieChartDisplayData = display;
      this._isAppUsageLoading = false;
      return;
    }

    if (this.isTourActive()) {
      // Always make API calls when tour is active, regardless of demo data status

      this._projectService.getAppUsageCount(start, end, this.selectedEmp)
        .subscribe(
          (res) => {
            let data = [];
            let label = [];
            let display = [];
            const chartData = this.getApplicationUsageData(res)
            chartData.forEach((item) => {
              label.push(item.appName);
              data.push(item.usageTime);
              display.push(item);
            })
            this.isPiechartLoad = false;
            this._projectService.updateApplicationUsageData({ data: data, label: label, display: display, start_date: this.datePipe.transform(start, "yyyy-MM-dd"), end_date: this.datePipe.transform(end, "yyyy-MM-dd") })
            this.pieChartData = data;
            this.pieChartLabel = label;
            this.pieChartDisplayData = display;
            this._isAppUsageLoading = false
          },
          (err) => {
            // Only show dummy data if we're in demo mode
            if (this.isShowingDemoData) {
              const demoRes = this._dummyDataService.getDataByParams<ApplicationUsage>('ApplicationUsage').data;
              let data = [];
              let label = [];
              let display = [];
              const chartData = this.getApplicationUsageData(demoRes)
              chartData.forEach((item) => {
                label.push(item.appName);
                data.push(item.usageTime);
                display.push(item);
              })
              this.isPiechartLoad = false;
              this._projectService.updateApplicationUsageData({ data: data, label: label, display: display, start_date: this.datePipe.transform(start, "yyyy-MM-dd"), end_date: this.datePipe.transform(end, "yyyy-MM-dd") })
              this.pieChartData = data;
              this.pieChartLabel = label;
              this.pieChartDisplayData = display;
            } else {
              // For real users, show empty state when API fails
              this.isPiechartLoad = false;
              this._projectService.updateApplicationUsageData({
                data: [],
                label: [],
                display: [],
                start_date: this.datePipe.transform(start, "yyyy-MM-dd"),
                end_date: this.datePipe.transform(end, "yyyy-MM-dd")
              });
              this.pieChartData = [];
              this.pieChartLabel = [];
              this.pieChartDisplayData = [];
            }
            this._isAppUsageLoading = false;
            this.isPiechartLoad = false;
          }
        );
    } else {
      this.isPiechartLoad = false;
      // Only show dummy data if we're in demo mode
      if (this.isShowingDemoData) {
        let data = [];
        let label = [];
        let display = [];
        let ApplicationJson: any = this._dummyDataService.getDataByParams<ApplicationUsage>('ApplicationUsage').data
        ApplicationJson.forEach((item) => {
          label.push(item.appName);
          data.push(item.usageTime);
          display.push(item);
        })
        this._projectService.updateApplicationUsageData({ data: data, label: label, display: display })
        this.pieChartData = data;
        this.pieChartLabel = label;
        this.pieChartDisplayData = display;
      } else {
        // For real users, show empty state
        this._projectService.updateApplicationUsageData({ data: [], label: [], display: [] })
        this.pieChartData = [];
        this.pieChartLabel = [];
        this.pieChartDisplayData = [];
      }
      this._isAppUsageLoading = false
    }
  }

  async getWebsiteUsageChartData(start, end) {
    this.isPieChartLoadWebsite = true;

    // Prioritize demo data if enabled
    if (this.isShowingDemoData) {
      const demoRes = this._dummyDataService.getDataByParams<WebsiteUsage>('WebsiteUsage').data;
      let data = [];
      let label = [];
      let display = [];
      const chartData = this.getApplicationUsageData(demoRes);
      chartData.forEach((item) => {
        label.push(item.appName);
        data.push(item.usageTime);
        display.push(item);
      })
      this.isPieChartLoadWebsite = false;
      this._projectService.updateWebsiteUsageChart({ data: data, label: label, display: display, start_date: this.datePipe.transform(this.startDateWebsiteUsageChart, "yyyy-MM-dd"), end_date: this.datePipe.transform(this.endDateWebsiteUsageChart, "yyyy-MM-dd") })
      this.pieChartDataWebsiteUsage = data;
      this.pieChartWebsiteUsageLabel = label;
      this.pieChartDisplayDataWebsite = display;
      this._isAppUsageLoading = false;
      return;
    }

    if (this.isTourActive()) {
      // Always make API calls when tour is active, regardless of demo data status

      this._projectService
        .getWebsiteUsageData(start, end, this.selectedEmp)
        .subscribe(
          (res) => {
            let data = [];
            let label = [];
            let display = [];
            const chartData = this.getApplicationUsageData(res);
            chartData.forEach((item) => {
              label.push(item.appName);
              data.push(item.usageTime);
              display.push(item);
            })
            this.isPieChartLoadWebsite = false;
            this._projectService.updateWebsiteUsageChart({ data: data, label: label, display: display, start_date: this.datePipe.transform(this.startDateWebsiteUsageChart, "yyyy-MM-dd"), end_date: this.datePipe.transform(this.endDateWebsiteUsageChart, "yyyy-MM-dd") })
            this.pieChartDataWebsiteUsage = data;
            this.pieChartWebsiteUsageLabel = label;
            this.pieChartDisplayDataWebsite = display;
            this._isAppUsageLoading = false
          },
          (err) => {
            // Only show dummy data if we're in demo mode
            if (this.isShowingDemoData) {
              const demoRes = this._dummyDataService.getDataByParams<WebsiteUsage>('WebsiteUsage').data;
              let data = [];
              let label = [];
              let display = [];
              const chartData = this.getApplicationUsageData(demoRes);
              chartData.forEach((item) => {
                label.push(item.appName);
                data.push(item.usageTime);
                display.push(item);
              })
              this.isPieChartLoadWebsite = false;
              this._projectService.updateWebsiteUsageChart({ data: data, label: label, display: display, start_date: this.datePipe.transform(this.startDateWebsiteUsageChart, "yyyy-MM-dd"), end_date: this.datePipe.transform(this.endDateWebsiteUsageChart, "yyyy-MM-dd") })
              this.pieChartDataWebsiteUsage = data;
              this.pieChartWebsiteUsageLabel = label;
              this.pieChartDisplayDataWebsite = display;
            } else {
              // For real users, show empty state when API fails
              this.isPieChartLoadWebsite = false;
              this._projectService.updateWebsiteUsageChart({
                data: [],
                label: [],
                display: [],
                start_date: this.datePipe.transform(this.startDateWebsiteUsageChart, "yyyy-MM-dd"),
                end_date: this.datePipe.transform(this.endDateWebsiteUsageChart, "yyyy-MM-dd")
              });
              this.pieChartDataWebsiteUsage = [];
              this.pieChartWebsiteUsageLabel = [];
              this.pieChartDisplayDataWebsite = [];
            }
            this.isPieChartLoadWebsite = false;
          }
        );
    } else {
      this.isPieChartLoadWebsite = false;
      // Only show dummy data if we're in demo mode
      if (this.isShowingDemoData) {
        let data = [];
        let label = [];
        let display = [];
        let ApplicationJson: any = this._dummyDataService.getDataByParams<ApplicationUsageLogs[]>('ApplicationLogs').data || [];
        ApplicationJson.forEach((item) => {
          label.push(item.appName);
          data.push(item.usageTime);
          display.push(item);
        })
        this._projectService.updateWebsiteUsageChart({ data: data, label: label, display: display })
        this.pieChartDataWebsiteUsage = data;
        this.pieChartWebsiteUsageLabel = label;
        this.pieChartDisplayDataWebsite = display;
      } else {
        // For real users, show empty state
        this._projectService.updateWebsiteUsageChart({ data: [], label: [], display: [] })
        this.pieChartDataWebsiteUsage = [];
        this.pieChartWebsiteUsageLabel = [];
        this.pieChartDisplayDataWebsite = [];
      }
      this._isAppUsageLoading = false
    }
  }

  getApplicationUsageData(appUsage) {
    let data = [];
    for (let key in appUsage) {
      if (key != "" || key) {
        data.push({ appName: key, usageTime: appUsage[key].usageTime != 0 ? appUsage[key].usageTime : '00:00:00', productive_time: appUsage[key].productive_time, idleTime: appUsage[key].idleTime });
      }
    }
    data.sort((a, b) => {
      const timeA = this.parseTime(a.usageTime);
      const timeB = this.parseTime(b.usageTime);
      return timeB - timeA;
    });
    const top10Array = data.slice(0, 10);
    return top10Array
  }

  parseTime(timeString) {
    if (timeString != 0) {
      const [hours, minutes, seconds] = timeString.split(":").map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    } else return "00:00:00"
  }

  getStackedChartData(start, search, end_date_param?) {
    const startStr = this.extractDateString(start, this.timelineSelectedDate?.startDate);
    const endStr = this.extractDateString(end_date_param, this.timelineSelectedDate?.endDate || moment(startStr));
    this.fetchTimelineConductTimelogs(startStr, endStr);

    this.clearPendingTimelineShiftFilterDebounce();
    this.isData = true;
    this._isStackbarLoading = true
    this.stackedArr = undefined;
    this.stackedChartlabel = [];
    this.stackedChartIds = [];
    if (this.isShowingDemoData) {
      // Prioritize demo data if enabled
      let newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
      this.makeStackBarChartData(newDataVal);
      this._isStackbarLoading = false;
      this.isData = true;
      return;
    }

    if (this.isTourActive()) {
      // Always make API calls when tour is active, regardless of demo data status
      const isDateTime = start && start.includes(":");
      let start_date_time = isDateTime ? start : (start ? start + ' 00:00:00' : '');
      let end_date_time;
      if (end_date_param) {
        end_date_time = end_date_param;
      }
      else if (isDateTime) {
        if (typeof this.enddate === 'string') {
          end_date_time = this.enddate;
        } else {
          end_date_time = this.datePipe.transform(this.enddate, 'yyyy-MM-dd HH:mm:ss');
        }
      }
      else {
        end_date_time = (start ? start + ' 23:59:59' : '');
      }
      let start_date = isDateTime ? '' : start;
      this
        ._projectService
        .getStackchartData(
          this.page,
          this.searchStack,
          this.filterTeamStackArr.join(','), start_date, '', start_date_time, end_date_time)
        .subscribe(
          async (data: any) => {
            data = JSON.parse(JSON.stringify(this._projectService.cleanStackChartData(data)))
            this.isData = true;
            for (let key in data) {
              if (key == "min") {
                const [hours, minutes, second] = data[key].split(":").map(Number);

                this.x_min = this.padZeroes(hours) + "." + this.padZeroes(minutes);
              } else if (key == "max") {
                if (data[key]) {
                  const [hours, minutes, second] = data[key].split(":").map(Number);
                  this.x_max = this.padZeroes(hours) + "." + this.padZeroes(minutes);
                }

              } else if (key == "total_users") {
                this.totalStack_user = Number(data[key]);
              }
            }
            if (Number(this.x_min) > Number(this.x_max)) {
              this.x_max = 23.59;
            } else {
              if (Number(this.x_max) - Number(this.x_min) < 8.0) {

                if (Number(this.x_min) + 8.0 > 23.59) {
                  this.x_max = 23.59;
                } else {
                  this.x_max = Number(this.x_min) + 8.0
                  this.x_max = Math.ceil(this.x_max)
                }
              } else {
                this.x_max = Math.ceil(this.x_max)
              }
            }

            delete data.max;
            delete data.min;
            const pageAdjusted = this.updateTimelinePaginationForTotalUsers();
            delete data.total_users;
            if (pageAdjusted) {
              this.getStackedChartData(start, search, end_date_param);
              return;
            }
            if (this.totalPage != this.page) {
              this.isData = true;
            } else {
              this.isData = false;
            }

            try {



              for (const date in data) {
                if (this.displayUserName(date) != '') {
                  data[date]["name"] = this.displayUserName(date);
                }
              }

              let sortedKey = Object.keys(data).sort((a, b) => {
                const nameA = (data[a]?.name || this.displayUserName(a) || '').toLowerCase();
                const nameB = (data[b]?.name || this.displayUserName(b) || '').toLowerCase();
                return nameA.localeCompare(nameB);
              });

              this.makeStackBarChartData(data, sortedKey);
              this._isStackbarLoading = false;

            } catch (error) {
              console.log("error", error)
              this._isStackbarLoading = false
            }
          },
          (err) => {
            console.log("err", err)
            if (err.status == 400) {
              if (this.page != 1) {
                this.isData = false;
              }
              this.totalPage = 0;
              this.totalStack_user = 0;
              this.startPage = 0;
              this.endPage = 0;

              // Only show dummy data if we're in demo mode
              if (this.isShowingDemoData) {
                const newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
                console.log(newDataVal, "newDataVal")
                this.makeStackBarChartData(newDataVal)
              } else {
                // For real users, show empty timeline
                this.stackedChartData = [];
              }
              this._isStackbarLoading = false
            }
          }
        );
    } else {
      // Only show dummy data if we're in demo mode
      if (this.isShowingDemoData) {
        let newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
        this.makeStackBarChartData(newDataVal)
      } else {
        // For real users, show empty timeline
        this.stackedChartData = [];
      }
      this._isStackbarLoading = false
    }
  }

  WeekPrevNextAction(prev) {
    if (prev) {
      if (this.page != 1) {
        this.startPage = this.startPage - 10;
        if (this.page == this.totalPage) {
          this.endPage = Math.floor(this.endPage / 10) * 10;
        } else {
          this.endPage = this.endPage - 10;
        }
        this.page = this.page - 1;

        // Use appropriate method based on mode for pagination
        if (this.isSingleDayActive) {
          this.getStackedChartData(
            this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
            this.searchStack,
            this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
          );
        } else {
          this.getStackedChartDataForVirtualShift(
            this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
            this.searchStack,
            this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
          );
        }

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { 'timeline-page': this.page > 1 ? this.page : null },
          queryParamsHandling: 'merge'
        });
      }
    } else {
      if (this.isData) {
        this.page = this.page + 1;
        this.startPage = this.startPage + 10;
        if (this.page == this.totalPage) {
          this.endPage = Number(this.totalStack_user);
        } else {
          this.endPage = this.endPage + 10;
        }

        // Use appropriate method based on mode for pagination
        if (this.isSingleDayActive) {
          this.getStackedChartData(
            this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
            this.searchStack,
            this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
          );
        } else {
          this.getStackedChartDataForVirtualShift(
            this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
            this.searchStack,
            this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
          );
        }

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { 'timeline-page': this.page },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  padZeroes(value: number) {
    return value.toString().padStart(2, '0');
  }

  async addMissingUsersForTimeline(data, users) {
    users.forEach((user: any) => {
      let found = false;
      for (const userId in data) {
        if (userId == user.id) found = true
      }

      if (!found) {
        data[user.id] = { sessions: [] }
      }
    })
    return data
  }

  private _processSessionLogs(sessions: any[]): any[] {
    return processTimelineSessionLogs(sessions);
  }

  private _sortSessionsByStartTime(sessions: any[]): any[] {
    if (!Array.isArray(sessions)) {
      return [];
    }
    return [...sessions].sort((a: any, b: any) => {
      const aTime = moment(a?.in, 'YYYY-MM-DD HH:mm:ss', true).valueOf();
      const bTime = moment(b?.in, 'YYYY-MM-DD HH:mm:ss', true).valueOf();
      return aTime - bTime;
    });
  }

  private _initializeDataset(logCount: number, dateCount: number): Map<string, any> {
    const dataset = new Map();
    const labels = ['nonusage', 'idle', 'usage'];
    const backgroundColors = [colors.timelineStates.nonusage, colors.timelineStates.idle, colors.timelineStates.active];

    for (let i = 0; i < logCount; i++) {
      labels.forEach((label, index) => {
        dataset.set(`${i}-${label}`, {
          // Chart.js v4 renders [0,0] floating bars as visible slivers at timeline start.
          // Use null for empty slots so rows/dates without data remain visually empty.
          data: Array(dateCount).fill(null),
          label: label,
          backgroundColor: backgroundColors[index],
          borderColor: 'rgba(255,255,255,0)',
          borderWidth: 0,
          barThickness: 35,
        });
      });
    }
    return dataset;
  }

  /**
   * Keep true idle visible even if app/window names are missing.
   * Only hide nameless usage segments (common artifact data in some logs).
   */
  private _getRenderableTimelineLabel(sessLog: any): 'nonusage' | 'idle' | 'usage' {
    const originalLabel = sessLog?.label === 'usage' ? 'usage' : (sessLog?.label === 'idle' ? 'idle' : 'nonusage');
    if (originalLabel === 'idle') {
      return 'idle';
    }
    const appName = typeof sessLog?.appName === 'string' ? sessLog.appName.trim() : '';
    const windowName = typeof sessLog?.windowName === 'string' ? sessLog.windowName.trim() : '';
    if (!appName && !windowName) {
      return 'nonusage';
    }
    return originalLabel;
  }

  async makeStackBarChartData(data, sortedKeys?: string[]) {
    try {
      if (!data) {
        return;
      }

      this.stackedChartIds = [];
      this.stackedChartlabel = [];
      this.tempDataTooltip = [];
      this.newSessionTimeline = [];
      const newDateLogs = [];

      for (const userId in data) {
        if (!data[userId]?.name && this.displayUserName(userId) != '') {
          data[userId]['name'] = this.displayUserName(userId);
        }
      }

      const sortedUserIds = (sortedKeys && sortedKeys.length)
        ? sortedKeys
        : Object.keys(data).sort((a, b) => {
          const nameA = (data[a]?.name || this.displayUserName(a) || '').toLowerCase();
          const nameB = (data[b]?.name || this.displayUserName(b) || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });

      for (const userId of sortedUserIds) {
        this.stackedChartIds.push(userId);
        const userName = data[userId]?.name || this.displayUserName(userId) || `ID: ${userId}`;
        const sessions = data[userId]?.sessions ? this._sortSessionsByStartTime(data[userId].sessions) : [];
        const chartData = this._sharedServices.gettingTheCorrectSession(sessions, 'timeline', userName);

        this.newSessionTimeline.push(sessions);
        this.tempDataTooltip.push(chartData.sessions);
        this.stackedChartlabel.push(userName);

        newDateLogs.push(this._processSessionLogs(sessions));
      }

      const maxLogs = Math.max(...newDateLogs.map((logs: any) => logs.length), 0);
      const dataset = this._initializeDataset(maxLogs, sortedUserIds.length);

      newDateLogs.forEach((dateSess: any, dateSessIn) => {
        dateSess.forEach((sessLog, sessLogIn) => {
          const renderLabel = this._getRenderableTimelineLabel(sessLog);
          const existingSessLog = dataset.get(`${sessLogIn}-${renderLabel}`);
          if (existingSessLog) {
            let in_offset = 0;
            let out_offset = 0;
            if (this.isVirtualShiftActive) {
              const startDate = this.timelineSelectedDate.startDate.clone().startOf('day');
              const inDate = moment(sessLog.inTime, 'YYYY-MM-DD HH:mm:ss').startOf('day');
              if (inDate.isAfter(startDate, 'day')) {
                in_offset = 24;
              }
              const outDate = moment(sessLog.outTime, 'YYYY-MM-DD HH:mm:ss').startOf('day');
              if (outDate.isAfter(startDate, 'day')) {
                out_offset = 24;
              }
            }

            const final_in = this._sharedServices.formateTimeInDecimal(sessLog.in) + in_offset;
            const final_out = this._sharedServices.formateTimeInDecimal(sessLog.out) + out_offset;

            existingSessLog.data[dateSessIn] = sessLog.in ? [final_in, final_out] : null;
            dataset.set(`${sessLogIn}-${renderLabel}`, {
              ...existingSessLog,
              ...sessLog,
              label: renderLabel,
              data: existingSessLog.data,
            });
          }
        });
      });

      this.stackedChartData = Array.from(dataset.values());
    } catch (error) {
      console.error(" ERROR in making stackbar chart data ", error);
    }
  }

  selectEmployee(value) {
    this.appUsageHours = null;
    this.workingHours = null;
    this.selectedEmp = value.toString();
    this.startDate = this.startDate
      ? this.startDate
      : this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    this.endDate = this.endDate
      ? this.endDate
      : this.datePipe.transform(this.enddate, "yyyy-MM-dd");

    this.startDateWebsiteUsageChart = this.startDateWebsiteUsageChart ? this.startDateWebsiteUsageChart : this.datePipe.transform(this.startDateForInput, "yyyy-MM-dd");
    this.endDateWebsiteUsageChart = this.endDateWebsiteUsageChart ? this.endDateWebsiteUsageChart : this.datePipe.transform(this.endDateForInput, "yyyy-MM-dd");

    this.getTotalHour(this.startDate, this.endDate);
    this.getPieChartData(this.startDate, this.endDate);
    this.getWebsiteUsageChartData(this.startDateWebsiteUsageChart, this.endDateWebsiteUsageChart);
    this.getLastScreenshots();
  }

  addTimes(timeArr) {
    const totalMilliseconds = timeArr
      .map((timeStr) => {
        const timeParts = timeStr.split(":");

        return (
          parseInt(timeParts[0]) * 3600000 +
          parseInt(timeParts[1]) * 60000 +
          parseInt(timeParts[2]) * 1000
        );
      })
      .reduce((acc, curr) => acc + curr, 0);

    const hours = Math.floor(totalMilliseconds / 3600000);
    const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
    const seconds = Math.floor((totalMilliseconds % 60000) / 1000);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  getCorrectData(photosData: any) {
    let data = photosData.map((ele) => {
      return {
        ...ele,
        captured_at: ele.ist_time,
        captured_time: ele.ist_time,
        timeDisplay: this.screenshotTime.getScreenshotTimeView(ele.ist_time, this.shiftTimezone),
      }
    });
    return data;
  }

  getUserfromUserList(userInfo) {
    let selectedUser = this.userList.filter((ele: any) => {
      return ele.id == parseInt(userInfo);
    });
    return selectedUser.length > 0 ? selectedUser[0] : null;
  }

  getUserName(userId) {
    let selectedUser = this.userList.filter((ele: any) => {
      if (ele.id == parseInt(userId)) {
        return ele.name;
      }
    });
    return selectedUser.length > 0 ? selectedUser[0].name : 'Unknown User';
  }

  convertTimeIntoFloat(time) {
    const [hours, minutes] = time.split(":").map(Number);

    const floatingValue = parseFloat(
      `${hours == "00" ? "24" : hours}.${minutes}`
    ).toFixed(2);
    return floatingValue;
  }

  timeToNumber(timeString) {
    var timeParts = timeString.split(":");
    var hours = parseInt(timeParts[0]);
    var minutes = parseInt(timeParts[1]);

    var decimalValue = hours + minutes / 60;

    decimalValue = Math.round(decimalValue * 100) / 100;
    return decimalValue;
  }

  getDashboardSection(section) {
    if (section == 'timeline') {
      this.timelineSection = true;
      this.screenshotSection = false;
      this.timelineBackground = 'timeline-section-btn-bg-color';
      this.screenshotBackground = '';
    } else if (section == 'screenshot') {
      this.timelineSection = false;
      this.screenshotSection = true;
      this.timelineBackground = '';
      this.screenshotBackground = 'timeline-section-btn-bg-color';
      // Load screenshots when the screenshot section is selected
      this.getLastScreenshots();
    }
  }

  onPageChange(event) {
    if (event.pageSize && event.pageSize > 0) {
      this.pageSize = event.pageSize;
      // Save pageSize to localStorage
      localStorage.setItem('pageSize', this.pageSize.toString());
    } else {
      // Fallback or default logic if pageSize is not in event
      // This part accesses a private member, which is not ideal. Consider using the event object if possible.
      if (this.EmpPaginator && this.EmpPaginator.pageSize) {
        this.pageSize = this.EmpPaginator.pageSize;
        localStorage.setItem('pageSize', this.pageSize.toString());
      }
      // If still no pageSize, might need a default or further check
    }

    // Use pageIndex from the event object directly for reliability
    const pageIndex = event.pageIndex; // Paginators usually emit pageIndex (0-based)
    this.offset = pageIndex + 1; // Assuming offset is 1-based
    this.currentPage = pageIndex + 1; // Assuming currentPage is 1-based

    this.getLastScreenshots();
  }

  getTotalOnlineOflineData() {
    if (this.isTourActive()) {
      // Team count: use demo teams or real teams list
      if (this.isShowingDemoData) {
        this.teamSize = this._dummyDataService.getDataByParams<Team[]>('TeamList').data.length;
      } else {
        this.teamSize = Array.isArray(this.teamsListForFilter) ? this.teamsListForFilter.length : 0;
      }
      // No comparison data from API; keep percentages at 0 and default icons
      this.onlinePercentage = 0;
      this.offlinePercentage = 0;
      this.onlinePercentageIcon = 'north';
      this.offlinePercentageIcon = 'north';
    } else {
      this.teamSize = this._dummyDataService.getDataByParams<Team[]>('TeamList').data.length;
    }
  }

  searchTimelineData(value: any) {
    this.searchStack = value;
    this.page = 1;
    this.filterTeam();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-search': value || null,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, {
      data,
      panelClass: 'centered-dialog',
    });
    return dialogRef.afterClosed();
  }

  applyTeamFilterCore(value: any) {
    if (!value) {
      this.selectedTeam = '';
      this.filterTeamStackArr = [];
      this.page = 1;
      return;
    }
    this.selectedTeam = value.title.rendered;
    this.currentTeam = this.selectedTeam;

    let getAllTeamDevIds = [];
    let getTeamLeadsIds = [];
    let getTeamManagerIds = [];

    if (this.isAdmin) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
      getTeamLeadsIds = this.getTeamsAllIds(value, "team_lead");
      getTeamManagerIds = this.getTeamsAllIds(value, "team_manager");
    }
    else if (this.isManager) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
      getTeamLeadsIds = this.getTeamsAllIds(value, "team_lead");
    }
    else if (this.isTeamLead) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
    }
    else {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
    }

    this.filterTeamStackArr = Array.from(new Set([...getAllTeamDevIds, ...getTeamLeadsIds, ...getTeamManagerIds]));
    this.page = 1;
  }

  teamSelected(value: any) {
    if (this.selectedTeam == this.currentTeam) {
      this.selectedTeam = '';
      this.filterTeamStackArr = [];
      this.page = 1;
      this.filterTeam();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'timeline-team': null,
          'timeline-page': null
        },
        queryParamsHandling: 'merge'
      });
      return;
    }
    this.currentTeam = this.selectedTeam;

    let getAllTeamDevIds = [];
    let getTeamLeadsIds = [];
    let getTeamManagerIds = [];

    console.log("filterTeamStackArr", this.isAdmin, this.isManager, this.isTeamLead)
    if (this.isAdmin) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
      getTeamLeadsIds = this.getTeamsAllIds(value, "team_lead");
      getTeamManagerIds = this.getTeamsAllIds(value, "team_manager");
    }
    else if (this.isManager) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
      getTeamLeadsIds = this.getTeamsAllIds(value, "team_lead");
    }
    else if (this.isTeamLead) {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
    }
    else {
      getAllTeamDevIds = this.getTeamsAllIds(value, "team_developer");
    }

    this.filterTeamStackArr = Array.from(new Set([...getAllTeamDevIds, ...getTeamLeadsIds, ...getTeamManagerIds]));
    console.log("filterTeamStackArr", this.filterTeamStackArr)
    this.page = 1;
    this.filterTeam();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-team': value.id,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }

  teamSelectionChange() {
    this.page = 1;
    if (this.selectedTeam === 'all') {
      // ... existing code ...
    }
  }

  searchUsersByTeams() { }

  getTeamsAllIds(data: any, type: any) {
    let teamDataString = data.meta[type];
    return teamDataString.split("~").filter((element) => {
      if (parseInt(element)) return parseInt(element)
    })
  }

  filterTeam() {
    // Use appropriate method based on current mode for filtering
    if (this.isSingleDayActive) {
      this.getStackedChartData(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
    } else {
      this.getStackedChartDataForVirtualShift(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const isProgressBarClicked = clickedElement.id === 'progress_bar';
    if (!isProgressBarClicked) {
      if (document.getElementById('TooltipId')) {
        var existingTooltip = document.getElementById('TooltipId');
        existingTooltip.parentNode.removeChild(existingTooltip);
      }
    }
  }

  trimName(name) {
    const trimmedName = name.length <= 20 ? name : name.slice(0, 20) + (name.length > 20 ? '...' : '');
    return trimmedName;
  }

  change(event: any) {
    if (this.selectedDateAndTime && this.selectedDateAndTime.startDate && this.selectedDateAndTime.endDate) {

      if (this.EmpPaginator) {
        this.EmpPaginator.firstPage()
      }
      this.offset = 0;
      this.currentPage = 1;
      this.getLastScreenshots();
    }
  }

  openDatepicker() {
    if (this.screenshotSection) {
      this.screenshotRangeDp?.open();
    }
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'https://media.licdn.com/dms/image/v2/D560BAQFo3lxYJInIYQ/company-logo_200_200/company-logo_200_200/0/1700226099820?e=2147483647&v=beta&t=gizaWEoz6lHKgOarc4issXjRlhvIh7m5xBWcrV0yIt8'; // Path to your fallback image
  }

  removeScreenShot(imageInfo) {
    const userName = this.getUserfromUserList(imageInfo.user_id)?.name || 'Unknown User';

    // Handle dummy screenshots differently
    if (this.isShowingDemoData) {
      this.sweetAlertService
        .showScreenshotConfirmation(imageInfo, userName)
        .then((result) => {
          if (result.isConfirmed) {
            this.sweetAlertService.showAlert('Deleted!', 'The screenshot has been removed.', 'success');
            // Regenerate dummy screenshots
            this.generateDummyScreenshots();
          }
        });
      return;
    }

    this.sweetAlertService
      .showScreenshotConfirmation(imageInfo, userName)
      .then((result) => {
        if (result.isConfirmed) {
          const screenshotIds = imageInfo.id
          this._projectService.removeScreenshots(screenshotIds).subscribe((removed) => {
            this.sweetAlertService.showAlert('Deleted!', 'The screenshot has been removed.', 'success')
            this.getLastScreenshots()
          }, (error) => {
            console.error(" Can not remove the screenshot")
          })
        }
      });
  }

  removeAllImages() {
    const totalImages = this.PhotoList.length;

    this.sweetAlertService
      .showRemoveAllImagesConfirmation(totalImages)
      .then((result) => {
        if (result.isConfirmed) {
          // Handle dummy screenshots differently
          if (this.isShowingDemoData) {
            swal.fire('Deleted!', 'All screenshots have been removed.', 'success');
            // Regenerate dummy screenshots
            this.generateDummyScreenshots();
            return;
          }

          const data = {
            "post_ids": this.PhotoList.map(item => Object.keys(item)[0])
          }

          swal.fire('Deleted!', 'All screenshots have been removed.', 'success');
          this.getLastScreenshots()
        } else {
          // Image removal canceled.
        }
      });
  }

  downloadScreenShot(imageInfo) {
    this.sweetAlertService.showDownloadProcess()
    const imageUrl = imageInfo.image_url;
    this.http.get(imageUrl + '?cacheblock=true', { responseType: 'blob' }).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.getUserfromUserList(imageInfo.user_id)?.name}_${imageInfo.captured_time}.png`; // Set the desired filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      Swal.close()
      window.URL.revokeObjectURL(url); // Free up memory
    });
  }

  downloadAll() {
    const urls = []
    const times = []
    const users = []

    this.sweetAlertService.showDownloadProcess()

    // Handle dummy screenshots differently
    if (this.isShowingDemoData) {
      this.PhotoList.forEach((photo) => {
        urls.push(photo.image_url)
        times.push(photo.captured_time)
        users.push(photo.user_id)
      });
    } else {
      this.PhotoList.forEach((photo) => {
        for (let key in photo) {
          if (photo.hasOwnProperty(key)) {
            if (photo[key]?.large) {
              urls.push(photo[key]?.large)
              times.push(photo[key]?.captured_time)
              users.push(photo[key]?.user_id)
            }
          }
        }
      })
    }

    const currentUser = this.tokenEncryptionService.getEncryptedItem<any>('user');
    const zipName = currentUser?.name || 'screenshots';
    this.downloadFilesAsZip(urls, zipName, times, users)
  }

  downloadFilesAsZip(urls: string[], zipFileName: string, times: string[], users: string[]): void {
    const zip = new JSZip();
    const folder = zip.folder(zipFileName);

    const filePromises = urls.map((url, index) => {
      return this.http.get(url, { responseType: 'blob' }).toPromise().then((blob) => {
        const fileName = `${this.getUserfromUserList(users[index])?.name} ${times[index]}.${url.split('.').pop()}`;
        folder?.file(fileName, blob);
      });
    });

    Promise.all(filePromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((zipFile) => {
        swal.close(); // Close the loading alert
        saveAs(zipFile, `${zipFileName}.zip`);
      });
    });
  }

  openOnlineMenu() {
    this.cancelCloseTimer();
    this.onlineMenuTrigger.openMenu();
  }

  openOfflineMenu() {
    setTimeout(() => {
      this.offlineMenuTrigger.openMenu();
    }, 100);
  }

  openIdleMenu() {
    this.cancelCloseTimer();
    this.idleMenuTrigger.openMenu();
  }

  getIdleStartTime(employee: any): string {
    if (employee?.fbEmployee?.idleStartTime) {
      return this.customtimeAgoPipe.transform(employee.fbEmployee.idleStartTime, 'lastActive');
    }
    return '';
  }

  getOfflineLastActiveTime(employee: any): string {
    if (employee?.fbEmployee) {
      if (employee.fbEmployee.lastOnlineAtTz) {
        return this.customtimeAgoPipe.transform(employee.fbEmployee.lastOnlineAtTz, 'lastActive');
      } else if (employee.fbEmployee.lastOnlineAt) {
        return this.customtimeAgoPipe.transform(employee.fbEmployee.lastOnlineAt, 'lastActive');
      }
    }
    return '';
  }

  isInvitedUser(employee: any): boolean {
    // User is invited if they don't have Firebase data (fbEmployee is null)
    return !employee?.fbEmployee;
  }

  clearChartData() {
    // Clear chart data to prevent caching issues when switching modes
    this.stackedChartData = [];
    this.stackedChartlabel = [];
    this.stackedChartIds = [];
    this.newSessionTimeline = [];
    this.tempDataTooltip = [];
    this.totalStack_user = 0;
    this.isData = false;

    // Force change detection to update the UI
    this.cdr.detectChanges();
  }

  setSingleDay() {
    this.isSingleDayActive = true;
    this.isVirtualShiftActive = false;
    this.timelineSelectedDate = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day')
    };
    this.page = 1;
    this.startPage = 1;
    this.endPage = this.totalPage * 10 < this.totalStack_user ? this.totalPage * 10 : this.totalStack_user;
    this.x_min = 0;
    this.x_max = 24;
    this.clearChartData();
    this.getStackedChartData(
      this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"),
      this.searchStack
    );
    this.syncTimelineSingleDayModelFromMoments();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-mode': '24h',
        'timeline-date': moment().format('YYYY-MM-DD'),
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }

  setVirtualShift() {
    this.isSingleDayActive = false;
    this.isVirtualShiftActive = true;
    const tomorrow = moment().add(1, 'days').endOf('day');
    const today = moment().startOf('day');
    this.timelineSelectedDate = {
      startDate: today,
      endDate: tomorrow
    };
    this.page = 1;
    this.startPage = 1;
    this.endPage = this.totalPage * 10 < this.totalStack_user ? this.totalPage * 10 : this.totalStack_user;
    this.x_min = 0;
    this.x_max = 47.59;
    this.clearChartData();
    this.getStackedChartDataForVirtualShift(
      this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"),
      this.searchStack,
      this.timelineSelectedDate.endDate.format("YYYY-MM-DD HH:mm:ss")
    );
    this.patchTimeline48RangeFromMoments();
    this.syncTimelineSingleDayModelFromMoments();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-mode': '48h',
        'timeline-date': `${today.format('YYYY-MM-DD')}_${tomorrow.format('YYYY-MM-DD')}`,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }

  getStackedChartDataForVirtualShift(start, search, end_date_param?) {
    const startStr = this.extractDateString(start, this.timelineSelectedDate?.startDate);
    const endStr = this.extractDateString(end_date_param, this.timelineSelectedDate?.endDate || moment(startStr));
    this.fetchTimelineConductTimelogs(startStr, endStr);

    this.clearPendingTimelineShiftFilterDebounce();
    this._isStackbarLoading = true;

    let start_date = this.datePipe.transform(start, "yyyy-MM-dd HH:mm:ss");
    let end_date = this.datePipe.transform(end_date_param, "yyyy-MM-dd HH:mm:ss");

    // if (this.timelineStartTime > this.timelineEndTime) {
    //   const startDate = moment(start);
    //   const endDate = startDate.add(1, 'days');
    //   end_date = this.datePipe.transform(endDate.toDate(), "yyyy-MM-dd HH:mm:ss");
    // }

    if (!end_date) {
      end_date = start_date;
    }
    this.isData = true;
    this.stackedArr = undefined;
    this.stackedChartlabel = [];
    this.stackedChartIds = [];

    if (this.isShowingDemoData) {
      // Prioritize demo data if enabled
      let newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
      this.makeStackBarChartDataForVirtualShift(newDataVal);
      this._isStackbarLoading = false;
      this.isData = true;
      return;
    }

    if (this.isTourActive()) {
      // Always make API calls when tour is active, regardless of demo data status
      const isDateTime = start && start.includes(":");
      let start_date_time = isDateTime ? start : (start ? start + ' 00:00:00' : '');
      let end_date_time = end_date_param || (isDateTime ?
        (typeof this.enddate === 'string' ? this.enddate : this.datePipe.transform(this.enddate, 'yyyy-MM-dd HH:mm:ss')) :
        (start ? start + ' 23:59:59' : ''));

      if (this.timelineStartTime > this.timelineEndTime) {
        end_date_time = end_date
      }

      this._projectService.getStackchartData(
        this.page,
        this.searchStack,
        this.filterTeamStackArr.join(','),
        start_date,
        '',
        start_date_time,
        end_date_time
      ).subscribe(
        async (data: any) => {
          data = JSON.parse(JSON.stringify(await this._projectService.cleanStackChartData(data)))
          this.isData = true;
          for (let key in data) {
            if (key == "min") {
              const [hours, minutes, second] = data[key].split(":").map(Number);
            } else if (key == "max") {
              if (data[key]) {
                const [hours, minutes, second] = data[key].split(":").map(Number);
              }
            } else if (key == "total_users") {
              this.totalStack_user = Number(data[key]);
            }
          }

          this.x_min = 0;
          this.x_max = 47.59;

          delete data.max;
          delete data.min;

          const pageAdjusted = this.updateTimelinePaginationForTotalUsers();
          delete data.total_users;
          if (pageAdjusted) {
            this.getStackedChartDataForVirtualShift(start, search, end_date_param);
            return;
          }

          if (this.totalPage != this.page) {
            this.isData = true;
          } else {
            this.isData = false;
          }

          for (const date in data) {
            if (this.displayUserName(date) != '') {
              data[date]["name"] = this.displayUserName(date);
            }
          }

          let sortedKey = Object.keys(data).sort((a, b) => {
            const nameA = (data[a]?.name || this.displayUserName(a) || '').toLowerCase();
            const nameB = (data[b]?.name || this.displayUserName(b) || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
          this.makeStackBarChartDataForVirtualShift(data, sortedKey);
          this._isStackbarLoading = false;
        },
        (err) => {
          if (err.status == 400) {
            if (this.page != 1) {
              this.isData = false;
            }
            this.totalPage = 0;
            this.totalStack_user = 0;
            this.startPage = 0;
            this.endPage = 0;

            // Only show dummy data if we're in demo mode
            if (this.isShowingDemoData) {
              const newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
              this.makeStackBarChartData(newDataVal)
            } else {
              // For real users, show empty timeline
              this.stackedChartData = [];
            }
            this._isStackbarLoading = false
          }
        }
      );
    } else {
      // Only show dummy data if we're in demo mode
      if (this.isShowingDemoData) {
        let newDataVal = this._dummyDataService.getDataByParams<ApplicationLogsTimeLine>('TimeLine').data;
        this.makeStackBarChartDataForVirtualShift(newDataVal);
      } else {
        // For real users, show empty timeline
        this.stackedChartData = [];
      }
      this._isStackbarLoading = false;
    }
  }

  // Enhanced method for processing virtual shift chart data (48 hours)
  async makeStackBarChartDataForVirtualShift(data, sortedKeys?: string[]) {
    try {
      console.log('START: makeStackBarChartDataForVirtualShift', { data });
      if (data) {
        this.stackedChartIds = [];
        this.stackedChartlabel = [];
        this.tempDataTooltip = [];
        this.newSessionTimeline = [];
        const newDateLogs = [];

        for (const userId in data) {
          if (!data[userId]?.name && this.displayUserName(userId) != '') {
            data[userId]['name'] = this.displayUserName(userId);
          }
        }

        const sortedUserIds = (sortedKeys && sortedKeys.length)
          ? sortedKeys
          : Object.keys(data).sort((a, b) => {
            const nameA = (data[a]?.name || this.displayUserName(a) || '').toLowerCase();
            const nameB = (data[b]?.name || this.displayUserName(b) || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });

        for (const date of sortedUserIds) { // loop user ids
          this.stackedChartIds.push(date);
          const userName = data[date]?.name || this.displayUserName(date) || `ID: ${date}`;
          console.group(`Processing user: ${userName}`);
          const sessions = data[date]?.sessions ? this._sortSessionsByStartTime(data[date].sessions) : []; // store sessions for current date
          console.log('sessions', sessions);
          const chartData = await this._sharedServices.gettingTheCorrectSession(sessions, 'timeline');
          await this.newSessionTimeline.push(sessions);
          await this.tempDataTooltip.push(chartData.sessions);
          await this.stackedChartlabel.push(userName);

          let sessionLogs = [];
          if (!sessions || !sessions.length) {
            newDateLogs.push(sessionLogs);
            console.groupEnd();
            continue;
          }

          console.log('timelineSelectedDate', this.timelineSelectedDate);
          // Enhanced date handling for virtual shift (48 hours) - moved outside loop
          const baseDate = this.timelineSelectedDate.startDate.clone().startOf('day');
          console.log('Start Time', baseDate);
          const day1End = baseDate.clone().endOf('day');
          console.log('day1End', day1End);

          const day2Start = baseDate.clone().add(1, 'day').startOf('day');
          console.log('day2Start', day2Start);

          const day2End = baseDate.clone().add(1, 'day').endOf('day');
          console.log('day2End', day2End);
          // console.log(day1End);

          for (let it = 0; it < sessions.length; it++) {
            const item = sessions[it];
            // console.log(`Processing session ${it + 1}/${sessions.length} for user ${userName}:`, { in: item.in, out: item.out, idle: item.idle, usage: item.usage });

            const usagebool = item.usage != "00:00:00";
            const idlebool = item.idle != "00:00:00";

            const itemInMoment = moment(item.in, 'YYYY-MM-DD HH:mm:ss');
            const itemOutMoment = moment(item.out, 'YYYY-MM-DD HH:mm:ss');

            // Determine if session starts on Day 1 or Day 2
            console.log('itemInMoment', itemInMoment);
            console.log('day2End', day2End);
            const sessionStartsOnDay1 = itemInMoment.isBetween(baseDate, day1End, undefined, '[]');
            console.log('sessionStartsOnDay1', sessionStartsOnDay1);
            const sessionStartsOnDay2 = itemInMoment.isBetween(day2Start, day2End, undefined, '[]');
            console.log('sessionStartsOnDay2', sessionStartsOnDay2);

            // Determine if session ends on Day 2
            const sessionEndsOnDay2 = itemOutMoment.isBetween(day2Start, day2End, undefined, '[]');

            // Check if the session spans from Day 1 to Day 2
            const sessionSpansAcrossDays = sessionStartsOnDay1 && sessionEndsOnDay2;

            if (sessionSpansAcrossDays) {
              console.log(`Session spans across days: ${itemInMoment.format('YYYY-MM-DD HH:mm:ss')} to ${itemOutMoment.format('YYYY-MM-DD HH:mm:ss')}`);

              // Split the session at midnight
              // First part: Day 1 (from session start to 23:59:59)
              const day1SessionIn = itemInMoment.format('HH:mm:ss');
              const day1SessionOut = '23:59:59';
              const day1Duration = this._sharedServices.formateTimeInDecimal(
                moment.duration(moment(`1970-01-01 ${day1SessionOut}`).diff(moment(`1970-01-01 ${day1SessionIn}`))).asHours().toFixed(2)
              );

              // Create Day 1 session log
              const day1SessionLog = {
                ...item,
                data: day1Duration,
                date: itemInMoment.format('YYYY-MM-DD'),
                in: day1SessionIn,
                out: day1SessionOut,
                label: idlebool ? 'idle' : 'usage',
                inTime: item.in,
                outTime: itemInMoment.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                dayOffset: 0 // Day 1
              };

              console.log('Day 1 part of split session:', { in: day1SessionIn, out: day1SessionOut, duration: day1Duration });
              sessionLogs.push(day1SessionLog);
              console.log('Pushed Day 1 log for split session:', sessionLogs);
              // Second part: Day 2 (from 00:00:00 to session end)
              const day2SessionIn = '00:00:00';
              const day2SessionOut = itemOutMoment.format('HH:mm:ss');
              const day2Duration = this._sharedServices.formateTimeInDecimal(
                moment.duration(moment(`1970-01-01 ${day2SessionOut}`).diff(moment(`1970-01-01 ${day2SessionIn}`))).asHours().toFixed(2)
              );
              console.log('Day 2 part of split session:', { in: day2SessionIn, out: day2SessionOut, duration: day2Duration });

              // Create Day 2 session log
              const day2SessionLog = {
                ...item,
                data: day2Duration,
                date: itemOutMoment.format('YYYY-MM-DD'),
                in: day2SessionIn,
                out: day2SessionOut,
                label: idlebool ? 'idle' : 'usage',
                inTime: itemOutMoment.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                outTime: item.out,
                dayOffset: 1 // Day 2
              };
              sessionLogs.push(day2SessionLog);
              console.log('Pushed Day 2 log for split session:', day2SessionLog);

              continue; // Skip the normal processing since we've handled this session
            }

            // For sessions that don't span across days, process normally
            const itemout = itemOutMoment.format('HH:mm:ss');
            const itemin = itemInMoment.format('HH:mm:ss');
            let data = this._sharedServices.formateTimeInDecimal(usagebool ? item.usage : item.idle);

            // Helper function to get day offset
            const getDayOffset = () => {
              const offset = sessionStartsOnDay2 ? 1 : 0;
              if (offset === 1) {
                console.log(`Session starts on Day 2. Assigning dayOffset: ${offset}`);
              }
              return offset;
            };

            if (it === 0) { // @note always consider first log to be either, never both.
              const sessionLog = {
                ...item,
                data,
                date: itemInMoment.format('YYYY-MM-DD'),
                in: itemin,
                out: itemout,
                label: idlebool ? 'idle' : 'usage',
                inTime: item.in,
                outTime: item.out,
                // Calculate proper day offset: 0 for Day 1, 1 for Day 2
                dayOffset: getDayOffset()
              }
              sessionLogs.push(sessionLog);
              if (sessionLog.dayOffset === 1) {
                console.log('Pushed first session log:', sessionLog);
              }
            }

            let prevSessionLog = { ...sessionLogs[sessionLogs.length - 1] };

            /** @note Enhanced logic for 48-hour virtual shift processing */
            if (it > 0 && !usagebool && idlebool && prevSessionLog['label'] === 'idle' && prevSessionLog['usage'] === "00:00:00") {
              const difference = this._sharedServices.getTimeDifference(prevSessionLog.out, itemin);
              /** @note if the difference is more than 1 minute seperate the logs */
              if (difference > 0.02 || (moment(prevSessionLog.outTime).day() !== moment(item.in).day())) {
                sessionLogs.push({ // will always be idle log
                  ...item,
                  data,
                  date: itemInMoment.format('YYYY-MM-DD'),
                  in: itemin,
                  out: itemout,
                  label: 'idle',
                  inTime: item.in,
                  outTime: item.out,
                  dayOffset: getDayOffset()
                });
              } else {
                prevSessionLog.out = itemout;
                prevSessionLog.data += data;
                prevSessionLog.appName = item.appName;
                prevSessionLog.windowName = item.windowName;
                prevSessionLog.outTime = item.out;
                prevSessionLog.dayOffset = getDayOffset();
                sessionLogs[sessionLogs.length - 1] = prevSessionLog;
                if (prevSessionLog.dayOffset === 1) {
                  console.log('Merged idle session:', prevSessionLog);
                }
              }
            }
            // Continue with existing logic but with enhanced day offset tracking
            else if (it > 0 && !usagebool && idlebool && prevSessionLog['label'] === 'usage') {
              sessionLogs.push({ // will always be idle log
                ...item,
                data,
                date: itemInMoment.format('YYYY-MM-DD'),
                in: itemin,
                out: itemout,
                label: 'idle',
                inTime: item.in,
                outTime: item.out,
                dayOffset: getDayOffset()
              });
            }
            /** @note Similar enhancements for other session combinations */
            else if (it > 0 && usagebool && !idlebool && prevSessionLog['label'] === 'usage' && prevSessionLog['idle'] === "00:00:00") {
              const difference = this._sharedServices.getTimeDifference(prevSessionLog.out, itemin)
              /** @note if the difference is more than 1 minute seperate the logs */
              if (difference > 0.02 || (moment(prevSessionLog.outTime).day() !== moment(item.in).day())) {
                sessionLogs.push({ // will always be usage log
                  ...item,
                  data,
                  date: itemInMoment.format('YYYY-MM-DD'),
                  in: itemin,
                  out: itemout,
                  label: 'usage',
                  inTime: item.in,
                  outTime: item.out,
                  dayOffset: getDayOffset()
                });
              } else {
                prevSessionLog.out = itemout;
                prevSessionLog.data += data;
                prevSessionLog.appName = item.appName;
                prevSessionLog.windowName = item.windowName;
                prevSessionLog.outTime = item.out;
                prevSessionLog.dayOffset = getDayOffset();
                sessionLogs[sessionLogs.length - 1] = prevSessionLog;
                if (prevSessionLog.dayOffset === 1) {
                  console.log('Merged usage session:', prevSessionLog);
                }
              }
            }
            else if (it > 0 && usagebool && !idlebool && prevSessionLog['label'] === 'idle') {
              sessionLogs.push({ // will always be usage log
                ...item,
                data,
                date: itemInMoment.format('YYYY-MM-DD'),
                in: itemin,
                out: itemout,
                label: 'usage',
                inTime: item.in,
                outTime: item.out,
                dayOffset: getDayOffset()
              });
            }
            else if (it > 0 && usagebool && idlebool && prevSessionLog['label'] === 'usage') {
              const newOutInTime = this._sharedServices.getNewTimeAfterDifference(item.idle, itemout);
              prevSessionLog.out = newOutInTime;
              prevSessionLog.data += data;
              prevSessionLog.appName = item.appName;
              prevSessionLog.windowName = item.windowName;
              prevSessionLog.outTime = itemInMoment.format('YYYY-MM-DD') + ' ' + newOutInTime;
              prevSessionLog.dayOffset = getDayOffset();
              sessionLogs[sessionLogs.length - 1] = prevSessionLog;
              sessionLogs.push({
                ...item,
                data: this._sharedServices.formateTimeInDecimal(item.idle),
                date: itemInMoment.format('YYYY-MM-DD'),
                in: newOutInTime,
                out: itemout,
                label: 'idle',
                inTime: itemInMoment.format('YYYY-MM-DD') + ' ' + newOutInTime,
                outTime: item.out,
                dayOffset: getDayOffset()
              });
              if (prevSessionLog.dayOffset === 1) {
                console.log('Merged usage+idle session into usage then idle:', prevSessionLog);
              }
            }
            else if (it > 0 && usagebool && idlebool && prevSessionLog['label'] === 'idle') {
              const newOutInTime = this._sharedServices.getNewTimeAfterDifference(item.usage, itemout);
              prevSessionLog.out = newOutInTime;
              prevSessionLog.data += data;
              prevSessionLog.appName = item.appName;
              prevSessionLog.windowName = item.windowName;
              prevSessionLog.outTime = item.out;
              prevSessionLog.dayOffset = getDayOffset();
              sessionLogs[sessionLogs.length - 1] = prevSessionLog;

              sessionLogs.push({ // will always be usage log
                ...item,
                data,
                appName: item.appName,
                windowName: item.windowName,
                date: itemInMoment.format('YYYY-MM-DD'),
                in: newOutInTime,
                out: itemOutMoment.format('HH:mm:ss'),
                label: 'usage',
                inTime: item.in,
                outTime: item.out,
                dayOffset: getDayOffset()
              });
            }
          }
          newDateLogs.push(sessionLogs);
          console.log(`Finished processing sessions for user ${userName}. Final logs for this user:`, sessionLogs);
          console.groupEnd();
        }

        // Same as single-day path: one row per session slot across all users (avoid overwriting
        // dataset keys when multiple employees have different session counts).
        const logLengthsVs = newDateLogs.map((logs: any) =>
          Array.isArray(logs) ? logs.length : 0
        );
        const maxLogsVs = logLengthsVs.length ? Math.max(...logLengthsVs) : 0;
        const dataset = this._initializeDataset(maxLogsVs, sortedUserIds.length);

        // Enhanced positioning calculation for 48-hour virtual shift
        newDateLogs.forEach((dateSess: any, dateSessIn) => {
          dateSess.forEach((sessLog, sessLogIn) => {
            const renderLabel = this._getRenderableTimelineLabel(sessLog);
            let existingSessLog = dataset.get(`${sessLogIn}-${renderLabel}`);
            if (existingSessLog) {
              // Use the dayOffset that was calculated during session processing
              const dayOffset = sessLog.dayOffset || 0;
              const in_offset = dayOffset * 24;

              const baseDate = this.timelineSelectedDate.startDate.clone().startOf('day');
              const outDate = moment(sessLog.outTime, 'YYYY-MM-DD HH:mm:ss').startOf('day');
              const dayDiff = outDate.diff(baseDate, 'days');
              const out_offset = dayDiff > dayOffset ? dayDiff * 24 : dayOffset * 24;


              const final_in = this._sharedServices.formateTimeInDecimal(sessLog.in) + in_offset;
              const final_out = this._sharedServices.formateTimeInDecimal(sessLog.out) + out_offset;

              console.log(`Positioning on timeline: ${final_in} to ${final_out} (offset by ${in_offset} hours)`);

              existingSessLog.data[dateSessIn] = sessLog.in ? [final_in, final_out] : null;
              dataset.set(`${sessLogIn}-${renderLabel}`, {
                ...existingSessLog,
                ...sessLog,
                label: renderLabel,
                data: existingSessLog.data,
              });
            }
          });
        });

        this.stackedChartData = Array.from(dataset.values());
      } else {
        // No Records Found for selected Dates
      }
    } catch (error) {
      console.error(" ERROR in making stackbar chart data for virtual shift ", error);
    }
  }

  onNextDate() {
    if (this.timelineSelectedDate && this.timelineSelectedDate.startDate) {
      const newStartDate = this.timelineSelectedDate.startDate.clone().add(1, 'day');
      if (newStartDate.isAfter(moment().endOf('day'))) return;
      this.resetTimelinePagination();
      if (this.isSingleDayActive) {
        this.timelineSelectedDate = {
          startDate: newStartDate,
          endDate: newStartDate.clone().endOf('day')
        };
        this.getStackedChartData(this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'), this.searchStack, this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss'));
        this.syncTimelineSingleDayModelFromMoments();

        const formatted = newStartDate.format('YYYY-MM-DD');
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            'timeline-date': formatted,
            'timeline-page': null
          },
          queryParamsHandling: 'merge'
        });
      } else {
        const newEndDate = this.timelineSelectedDate.endDate.clone().add(1, 'day');
        this.timelineSelectedDate = {
          startDate: newStartDate,
          endDate: newEndDate
        };
        this.getStackedChartDataForVirtualShift(this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'), this.searchStack, this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss'));
        this.patchTimeline48RangeFromMoments();
        this.syncTimelineSingleDayModelFromMoments();

        const formatted = `${newStartDate.format('YYYY-MM-DD')}_${newEndDate.format('YYYY-MM-DD')}`;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            'timeline-date': formatted,
            'timeline-page': null
          },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  onNextDateSS() {
    if (this.selectedDateAndTime && this.selectedDateAndTime.startDate) {
      this.selectedDateAndTime.startDate.add(1, 'day');
      this.selectedDateAndTime.endDate.add(1, 'day');
      this.patchScreenshotDateRangeFromMoments();
      this.change(this.selectedDateAndTime);
    }
  }

  onPreviousDateSS() {
    if (this.selectedDateAndTime && this.selectedDateAndTime.startDate) {
      this.selectedDateAndTime.startDate.subtract(1, 'day');
      this.selectedDateAndTime.endDate.subtract(1, 'day');
      this.patchScreenshotDateRangeFromMoments();
      this.change(this.selectedDateAndTime);
    }
  }

  onPreviousDate() {
    if (this.timelineSelectedDate && this.timelineSelectedDate.startDate) {
      const newStartDate = this.timelineSelectedDate.startDate.clone().subtract(1, 'day');
      this.resetTimelinePagination();
      if (this.isSingleDayActive) {
        this.timelineSelectedDate = {
          startDate: newStartDate,
          endDate: newStartDate.clone().endOf('day')
        };
        this.getStackedChartData(this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'), this.searchStack, this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss'));
        this.syncTimelineSingleDayModelFromMoments();

        const formatted = newStartDate.format('YYYY-MM-DD');
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            'timeline-date': formatted,
            'timeline-page': null
          },
          queryParamsHandling: 'merge'
        });
      } else {
        const newEndDate = this.timelineSelectedDate.endDate.clone().subtract(1, 'day');
        this.timelineSelectedDate = {
          startDate: newStartDate.clone().startOf('day'),
          endDate: newEndDate.clone().endOf('day')
        };
        this.getStackedChartDataForVirtualShift(this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'), this.searchStack, this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss'));
        this.patchTimeline48RangeFromMoments();
        this.syncTimelineSingleDayModelFromMoments();

        const formatted = `${newStartDate.format('YYYY-MM-DD')}_${newEndDate.format('YYYY-MM-DD')}`;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            'timeline-date': formatted,
            'timeline-page': null
          },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  cancelCloseTimer() {
    if (this.closeMenuTimeout) {
      clearTimeout(this.closeMenuTimeout);
      this.closeMenuTimeout = null;
    }
  }

  onChosenDate(event: { startDate: moment.Moment, endDate: moment.Moment }) {
    this.resetTimelinePagination();
    this.timelineSelectedDate = event;

    if (this.isSingleDayActive) {
      if (this.timelineSelectedDate.startDate) {
        // Since it's a single day, set end time to the end of the selected day
        this.timelineSelectedDate.endDate = this.timelineSelectedDate.startDate.clone().endOf('day');
      }

      this.getStackedChartData(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
      this.syncTimelineSingleDayModelFromMoments();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'timeline-date': this.timelineSelectedDate.startDate.format('YYYY-MM-DD'),
          'timeline-page': null
        },
        queryParamsHandling: 'merge'
      });
    } else if (this.isVirtualShiftActive) {
      if (this.timelineSelectedDate.startDate) {
        const start = this.timelineSelectedDate.startDate.clone().startOf('day');
        const end = this.timelineSelectedDate.endDate.clone().endOf('day');
        if (end.isSame(start, 'day')) {
          end.add(1, 'day');
        }
        this.timelineSelectedDate = { startDate: start, endDate: end };
        this.getStackedChartDataForVirtualShift(
          this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"),
          this.searchStack,
          this.timelineSelectedDate.endDate.format("YYYY-MM-DD HH:mm:ss")
        );
        this.syncTimelineSingleDayModelFromMoments();

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            'timeline-date': `${this.timelineSelectedDate.startDate.format('YYYY-MM-DD')}_${this.timelineSelectedDate.endDate.format('YYYY-MM-DD')}`,
            'timeline-page': null
          },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  onChosen48HoursDate(event: { startDate: any, endDate: any }) {
    if (event.startDate && event.endDate) {
      this.resetTimelinePagination();
      let startDateConverted = event.startDate.startOf('day').format("DD-MM-YYYY");
      let endDateConverted = event.endDate.endOf('day').format("DD-MM-YYYY");
      const start = moment(startDateConverted, "DD-MM-YYYY").startOf('day');
      let end = moment(endDateConverted, "DD-MM-YYYY").endOf('day');
      const maxAllowedEnd = start.clone().add(1, 'day').endOf('day');
      if (end.isAfter(maxAllowedEnd)) {
        end = maxAllowedEnd;
      }
      if (end.isSame(start, 'day')) {
        end.add(1, 'day');
      }

      this.timelineSelectedDate = { startDate: start, endDate: end };

      this.getStackedChartDataForVirtualShift(
        this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"),
        this.searchStack,
        this.timelineSelectedDate.endDate.format("YYYY-MM-DD HH:mm:ss")
      );
      this.patchTimeline48RangeFromMoments();
      this.syncTimelineSingleDayModelFromMoments();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'timeline-date': `${this.timelineSelectedDate.startDate.format('YYYY-MM-DD')}_${this.timelineSelectedDate.endDate.format('YYYY-MM-DD')}`,
          'timeline-page': null
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  onChosen24HoursDate(event: { startDate: any, endDate: any }) {
    if (event.startDate) {
      this.resetTimelinePagination();
      // For single day selection, both start and end dates should be the same day.
      let startDateConverted = event.startDate.startOf('day').format("DD-MM-YYYY");
      let endDateConverted = event.startDate.endOf('day').format("DD-MM-YYYY");
      const start = moment(startDateConverted, "DD-MM-YYYY").startOf('day');
      const end = moment(endDateConverted, "DD-MM-YYYY").endOf('day');
      this.timelineSelectedDate = { startDate: start, endDate: end };

      this.getStackedChartData(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
      this.syncTimelineSingleDayModelFromMoments();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'timeline-date': this.timelineSelectedDate.startDate.format('YYYY-MM-DD'),
          'timeline-page': null
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  isInvalidDate = (m: moment.Moment) => {
    return false;
  }

  getDividerPosition(): number {
    // Calculate the position of the 24-hour divider as a percentage
    // In virtual shift mode, we have a 48-hour timeline (0-47.99 hours)
    // The divider should be at the 24-hour mark, which is 50% of 48 hours
    if (this.isVirtualShiftActive) {
      const totalHours = this.x_max ? parseFloat(this.x_max) : 48;
      const minHours = this.x_min ? parseFloat(this.x_min) : 0;
      const dividerHour = 24;

      // Calculate the percentage position accounting for the actual data range
      const range = totalHours - minHours;
      const position = ((dividerHour - minHours) / range) * 100;

      // Adjust for chart padding/margins - typically charts have ~10% padding on each side
      const chartPaddingAdjustment = 8; // Adjust this value to fine-tune alignment
      return Math.max(0, Math.min(100, position - chartPaddingAdjustment));
    }
    return 50; // Default to 50% if not in virtual shift mode
  }

  /** Debounced refetch while adjusting shift start/end (no Apply button). */
  scheduleTimelineShiftTimeFilterApply(): void {
    this.clearPendingTimelineShiftFilterDebounce();
    this.timelineShiftFilterDebounceId = setTimeout(() => {
      this.timelineShiftFilterDebounceId = null;
      this.applyTimelineTimeFilterCore();
    }, this.timelineShiftFilterDebounceMs);
  }

  private clearPendingTimelineShiftFilterDebounce(): void {
    if (this.timelineShiftFilterDebounceId != null) {
      clearTimeout(this.timelineShiftFilterDebounceId);
      this.timelineShiftFilterDebounceId = null;
    }
  }

  get hasTimelineShiftSelection(): boolean {
    return Boolean(this.timelineStartTime && this.timelineEndTime);
  }

  private applyTimelineTimeFilterCore(): void {
    if (this.timelineStartTime && this.timelineEndTime) {
      this.resetTimelinePagination();

      if (this.isSingleDayActive) {
        this.getStackedChartData(this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"), this.searchStack);
      } else {
        this.getStackedChartDataForVirtualShift(this.timelineSelectedDate.startDate.format("YYYY-MM-DD HH:mm:ss"), this.searchStack, this.timelineSelectedDate.endDate.format("YYYY-MM-DD HH:mm:ss"));
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          'timeline-shift': `${this.timelineStartTime}_${this.timelineEndTime}`,
          'timeline-page': null
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  clearTimelineShiftSelection(): void {
    this.clearPendingTimelineShiftFilterDebounce();
    if (!this.hasTimelineShiftSelection) {
      return;
    }
    this.timelineStartTime = null;
    this.timelineEndTime = null;
    this.resetTimelinePagination();
    if (this.isSingleDayActive) {
      this.getStackedChartData(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
    } else {
      this.getStackedChartDataForVirtualShift(
        this.timelineSelectedDate.startDate.format('YYYY-MM-DD HH:mm:ss'),
        this.searchStack,
        this.timelineSelectedDate.endDate.format('YYYY-MM-DD HH:mm:ss')
      );
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        'timeline-shift': null,
        'timeline-page': null
      },
      queryParamsHandling: 'merge'
    });
  }

  private resetTimelinePagination(): void {
    this.page = 1;
    this.startPage = 1;
    this.endPage = 10;
    this.totalPage = 1;
    this.totalStack_user = 0;
    this.isData = true;
  }

  private updateTimelinePaginationForTotalUsers(): boolean {
    const pageSize = 10;
    const totalUsers = Number(this.totalStack_user) || 0;

    if (totalUsers <= 0) {
      this.totalPage = 0;
      this.page = 1;
      this.startPage = 0;
      this.endPage = 0;
      this.isData = false;
      return false;
    }

    this.totalPage = Math.ceil(totalUsers / pageSize);

    // If current page is no longer valid for the newly filtered result,
    // move to last valid page and trigger a refetch.
    if (this.page > this.totalPage) {
      this.page = this.totalPage;
      return true;
    }

    this.startPage = (this.page - 1) * pageSize + 1;
    this.endPage = Math.min(this.page * pageSize, totalUsers);
    this.isData = this.page < this.totalPage;
    return false;
  }

  /**
   * Generate dummy screenshots for demo mode
   */
  generateDummyScreenshots() {
    const dummyScreenshots = [];
    const appNames = ['Google Chrome', 'Microsoft Edge', 'Safari', 'Adobe Premiere Pro', 'Visual Studio Code', 'Spotify', 'Slack', 'Discord', 'Figma', 'Notion'];
    const screenshotTypes = ['periodic', 'app-changed', 'admin-request'];

    // Generate 18 dummy screenshots (matching the pagination count)
    for (let i = 0; i < 18; i++) {
      const userId = 1000 + (i % 5); // Cycle through User1-User5
      const appName = appNames[i % appNames.length];
      const screenshotType = screenshotTypes[i % screenshotTypes.length];

      const ct = moment().subtract(i * 5, 'minutes').format('YYYY-MM-DD HH:mm:ss');
      const dummyScreenshot = {
        id: i + 1,
        user_id: userId,
        app_name: appName,
        image_url: this.getDummyScreenshotImage(i),
        ist_time: ct,
        captured_at: ct,
        captured_time: ct,
        timeDisplay: this.screenshotTime.getScreenshotTimeView(ct, this.shiftTimezone),
        type: screenshotType,
      };

      dummyScreenshots.push(dummyScreenshot);
    }

    this.PhotoList = dummyScreenshots;
    this.total_ss = dummyScreenshots.length;
  }

  /**
 * Generate a dummy screenshot image based on user and app
 */
  getDummyScreenshotImage(index: number): string {
    // Use local screenshot images from assets folder
    const screenshotImages = [
      'assets/screenshots/1.png',
      'assets/screenshots/2.png',
      'assets/screenshots/3.png',
      'assets/screenshots/4.png',
      'assets/screenshots/5.png',
      'assets/screenshots/6.png',
      'assets/screenshots/7.png',
      'assets/screenshots/8.png',
      'assets/screenshots/9.png',
      'assets/screenshots/10.png',
      'assets/screenshots/11.png',
      'assets/screenshots/12.png',
      'assets/screenshots/13.png',
      'assets/screenshots/14.png',
      'assets/screenshots/15.png',
      'assets/screenshots/16.png',
      'assets/screenshots/17.png',
      'assets/screenshots/18.png',
    ];

    // Use modulo to cycle through the available images
    return screenshotImages[index];
  }

  checkUserIsAutoLogout(user: any) {
    if (user.logoutReason && user.lastOnlineAtTz) {
      const logoutTime = moment.utc(user.logoutReason.time);
      const lastOnlineTime = moment.utc(user.lastOnlineAtTz);
      return logoutTime.isAfter(lastOnlineTime);
    } else {
      return false
    }
  }

  setTimeRangeForDateInputs() {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id ?? user?.company_id;
    const dateToUse = user?.meta?.today_date || new Date();
    this._sharedServices.getValidationDateRangeByCompany(dateToUse, companyId).subscribe((range) => {
      this.maxApplicationUsageDate = range.maxDate;
      this.maxWebsiteUsageDate = range.maxDate;
      this.maxDateForTimeLine = range.maxDate;
      this.minApplicationUsageDate = range.minDate;
      this.minWebsiteUsageDate = range.minDate;
      this.minDateForTimeLine = range.minDate;
      this.minConductDate = range.minDate ? this.toMaterialDate(range.minDate) : null;
      const todayEnd = moment().endOf('day').toDate();
      const rangeMax = range.maxDate ? this.toMaterialDate(range.maxDate) : null;
      this.maxConductDate = (rangeMax && rangeMax < todayEnd) ? rangeMax : todayEnd;
      this.refreshTimelineMaterialDateBounds();
    });
  }

  /** Prefill "Shift Start/End Time" from Settings → Shift (company shift API). */
  private prefillTimelineShiftFromCompanySettings(companyId: number | string | undefined): void {
    if (companyId == null || companyId === '') {
      return;
    }
    if (this.timelineStartTime || this.timelineEndTime) {
      return;
    }
    const id = Number(companyId);
    if (!Number.isFinite(id)) {
      return;
    }
    this.shiftService
      .getShifts(id)
      .pipe(take(1))
      .subscribe({
        next: (shifts) => {
          const shift = shifts?.[0];
          if (!shift) {
            return;
          }
          const start = this.normalizeTimelineTime(shift.start_time);
          const end = this.normalizeTimelineTime(shift.end_time);
          if (start && end) {
            this.timelineStartTime = start;
            this.timelineEndTime = end;
            this.cdr.detectChanges();
          }
        },
        error: () => { },
      });
  }

  /** HH:mm for native time input (API may return HH:mm:ss). */
  private normalizeTimelineTime(raw: string | null | undefined): string | null {
    if (raw == null || typeof raw !== 'string') {
      return null;
    }
    const trimmed = raw.trim();
    const match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?/.exec(trimmed);
    if (!match) {
      return null;
    }
    const h = match[1].padStart(2, '0');
    const m = match[2].padStart(2, '0');
    return `${h}:${m}`;
  }
}
